/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestSvgRouteImport } from './routes/test-svg'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as FigmaAuthRouteImport } from './routes/figma-auth'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as WRouteRouteImport } from './routes/w/route'
import { Route as AdminSkidogRouteRouteImport } from './routes/admin-skidog/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WIndexRouteImport } from './routes/w/index'
import { Route as PIndexRouteImport } from './routes/p.index'
import { Route as AdminSkidogIndexRouteImport } from './routes/admin-skidog/index'
import { Route as WQueueRouteImport } from './routes/w/queue'
import { Route as WNotificationsRouteImport } from './routes/w/notifications'
import { Route as WCapacityRouteImport } from './routes/w/capacity'
import { Route as PTokenRouteImport } from './routes/p.$token'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthConfirmRouteImport } from './routes/auth/confirm'
import { Route as AdminSkidogTemplatesRouteImport } from './routes/admin-skidog/templates'
import { Route as AdminSkidogTemplateTransfersRouteImport } from './routes/admin-skidog/template-transfers'
import { Route as AdminSkidogStaffRouteImport } from './routes/admin-skidog/staff'
import { Route as AdminSkidogShowcaseRouteImport } from './routes/admin-skidog/showcase'
import { Route as AdminSkidogSam3PlaygroundRouteImport } from './routes/admin-skidog/sam3-playground'
import { Route as AdminSkidogPlansRouteImport } from './routes/admin-skidog/plans'
import { Route as AdminSkidogOrganizationsRouteImport } from './routes/admin-skidog/organizations'
import { Route as AdminSkidogIntegrationTasksRouteImport } from './routes/admin-skidog/integration-tasks'
import { Route as AdminSkidogFeatureFlagsRouteImport } from './routes/admin-skidog/feature-flags'
import { Route as AdminSkidogEmailDocumentsRouteImport } from './routes/admin-skidog/email-documents'
import { Route as AdminSkidogDashboardRouteImport } from './routes/admin-skidog/dashboard'
import { Route as AdminSkidogCapacityRouteImport } from './routes/admin-skidog/capacity'
import { Route as AdminSkidogBgRemovalRouteImport } from './routes/admin-skidog/bg-removal'
import { Route as AdminSkidogAiCostsRouteImport } from './routes/admin-skidog/ai-costs'
import { Route as AcceptInvitationTokenRouteImport } from './routes/accept-invitation/$token'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AdminSkidogWhiteGloveIndexRouteImport } from './routes/admin-skidog/white-glove/index'
import { Route as AdminSkidogEmailArchiveIndexRouteImport } from './routes/admin-skidog/email-archive/index'
import { Route as AdminSkidogDesignInspirationsIndexRouteImport } from './routes/admin-skidog/design-inspirations/index'
import { Route as AdminSkidogOrgIdIndexRouteImport } from './routes/admin-skidog/$orgId.index'
import { Route as AuthedDashboardIndexRouteImport } from './routes/_authed/dashboard/index'
import { Route as WTicketsTicketIdRouteImport } from './routes/w/tickets/$ticketId'
import { Route as WBrandReviewsReviewIdRouteImport } from './routes/w/brand-reviews/$reviewId'
import { Route as ClientTransfersClaimTokenRouteImport } from './routes/client-transfers/claim/$token'
import { Route as AdminSkidogWhiteGloveEngagementIdRouteImport } from './routes/admin-skidog/white-glove/$engagementId'
import { Route as AdminSkidogEmailDocumentTemplatesIdRouteImport } from './routes/admin-skidog/email-document-templates/$id'
import { Route as AdminSkidogEmailDocumentSectionsIdRouteImport } from './routes/admin-skidog/email-document-sections/$id'
import { Route as AuthedDashboardNotificationsRouteImport } from './routes/_authed/dashboard/notifications'
import { Route as AuthedIntegrationsKlaviyoIndexRouteImport } from './routes/_authed/integrations/klaviyo/index'
import { Route as WTicketsTicketIdLiveRouteImport } from './routes/w/tickets/$ticketId.live'
import { Route as AdminSkidogOrgIdClientsClientIdRouteImport } from './routes/admin-skidog/$orgId.clients.$clientId'
import { Route as AuthedIntegrationsKlaviyoInstallRouteImport } from './routes/_authed/integrations/klaviyo/install'
import { Route as AuthedIntegrationsKlaviyoCallbackRouteImport } from './routes/_authed/integrations/klaviyo/callback'
import { Route as AuthedDashboardTestCanvaskitRouteImport } from './routes/_authed/dashboard/test/canvaskit'
import { Route as AuthedDashboardTestCanvasPreviewRouteImport } from './routes/_authed/dashboard/test/canvas-preview'
import { Route as AuthedDashboardOOrgIdRouteRouteImport } from './routes/_authed/dashboard/o/$orgId/route'
import { Route as AuthedDashboardOOrgIdSettingsRouteImport } from './routes/_authed/dashboard/o/$orgId/settings'
import { Route as AuthedDashboardOOrgIdClientsRouteImport } from './routes/_authed/dashboard/o/$orgId/clients'
import { Route as AuthedDashboardOOrgIdWhiteGloveIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/white-glove/index'
import { Route as AuthedDashboardOOrgIdSettingsIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/index'
import { Route as AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRouteImport } from './routes/admin-skidog/$orgId.clients.$clientId.integrations.$integrationId'
import { Route as AuthedDashboardOOrgIdWhiteGloveTasksRouteImport } from './routes/_authed/dashboard/o/$orgId/white-glove/tasks'
import { Route as AuthedDashboardOOrgIdSettingsProfileRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/profile'
import { Route as AuthedDashboardOOrgIdSettingsAccountRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/account'
import { Route as AuthedDashboardOOrgIdCClientIdRouteRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/route'
import { Route as AuthedDashboardOOrgIdSettingsProfileIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/profile/index'
import { Route as AuthedDashboardOOrgIdCClientIdIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/index'
import { Route as AuthedDashboardOOrgIdSettingsOrganizationTeamRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/organization/team'
import { Route as AuthedDashboardOOrgIdSettingsOrganizationGeneralRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/organization/general'
import { Route as AuthedDashboardOOrgIdSettingsOrganizationClientsRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/organization/clients'
import { Route as AuthedDashboardOOrgIdSettingsOrganizationBillingRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/organization/billing'
import { Route as AuthedDashboardOOrgIdSettingsOrganizationApiRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/organization/api'
import { Route as AuthedDashboardOOrgIdSettingsIntegrationsShopifyRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/integrations/shopify'
import { Route as AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/integrations/mailchimp'
import { Route as AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/integrations/klaviyo'
import { Route as AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/integrations/google-drive'
import { Route as AuthedDashboardOOrgIdSettingsClientIntegrationsRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/integrations'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand'
import { Route as AuthedDashboardOOrgIdCClientIdEmailImgUploadRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/email-img-upload'
import { Route as AuthedDashboardOOrgIdCClientIdCreateRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/create'
import { Route as AuthedDashboardOOrgIdCClientIdContentBlocksRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/content-blocks'
import { Route as AuthedDashboardOOrgIdCClientIdAuditRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/audit'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/route'
import { Route as AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/templates/route'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/route'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/index'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/index'
import { Route as AuthedDashboardOOrgIdCClientIdTemplatesIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/templates/index'
import { Route as AuthedDashboardOOrgIdCClientIdSectionsIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/sections/index'
import { Route as AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/media-library/index'
import { Route as AuthedDashboardOOrgIdCClientIdInspoIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/inspo/index'
import { Route as AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/image-generator/index'
import { Route as AuthedDashboardOOrgIdCClientIdFlowsIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/flows/index'
import { Route as AuthedDashboardOOrgIdCClientIdCalendarIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/calendar/index'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/index'
import { Route as AuthedDashboardOOrgIdCClientIdSectionsIdRouteImport } from './routes/_authed/dashboard_/o/$orgId/c/$clientId/sections/$id'
import { Route as AuthedDashboardOOrgIdCClientIdFlowsCreateRouteImport } from './routes/_authed/dashboard_/o/$orgId/c/$clientId/flows/create'
import { Route as AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteImport } from './routes/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandProfilesRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/profiles'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/integrations'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveTryRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/try'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tasks'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/schedule'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/month'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/intake'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/header'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/footer'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/calendar'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/briefs'
import { Route as AuthedDashboardOOrgIdCClientIdTemplatesMyRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/templates/my'
import { Route as AuthedDashboardOOrgIdCClientIdTemplatesLibraryRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/templates/library'
import { Route as AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId'
import { Route as AuthedDashboardOOrgIdCClientIdEmailsNewRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/emails/new'
import { Route as AuthedDashboardOOrgIdCClientIdEmailsCreateRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/emails/create'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/revenue'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/orders'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/list-growth'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/flows'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/campaigns'
import { Route as AuthedDashboardOOrgIdCClientIdAnalyticsAuditRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/analytics/audit'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/index'
import { Route as AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRouteImport } from './routes/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId.edit'
import { Route as AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRouteImport } from './routes/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId.edit'
import { Route as AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRouteImport } from './routes/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId.chat'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets.$ticketId'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/review.$ticketId'
import { Route as AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/media-library/canvas.$canvasId'
import { Route as AuthedDashboardOOrgIdCClientIdInspoListsListIdRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/inspo/lists.$listId'
import { Route as AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/inspo/brands.$slug'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/products/index'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/index'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor'
import { Route as AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRouteImport } from './routes/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo'
import { Route as AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRouteImport } from './routes/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets.$ticketId.review'

const TestSvgRoute = TestSvgRouteImport.update({
  id: '/test-svg',
  path: '/test-svg',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const FigmaAuthRoute = FigmaAuthRouteImport.update({
  id: '/figma-auth',
  path: '/figma-auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const WRouteRoute = WRouteRouteImport.update({
  id: '/w',
  path: '/w',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSkidogRouteRoute = AdminSkidogRouteRouteImport.update({
  id: '/admin-skidog',
  path: '/admin-skidog',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WIndexRoute = WIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WRouteRoute,
} as any)
const PIndexRoute = PIndexRouteImport.update({
  id: '/p/',
  path: '/p/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSkidogIndexRoute = AdminSkidogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const WQueueRoute = WQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => WRouteRoute,
} as any)
const WNotificationsRoute = WNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => WRouteRoute,
} as any)
const WCapacityRoute = WCapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => WRouteRoute,
} as any)
const PTokenRoute = PTokenRouteImport.update({
  id: '/p/$token',
  path: '/p/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConfirmRoute = AuthConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => AuthRoute,
} as any)
const AdminSkidogTemplatesRoute = AdminSkidogTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogTemplateTransfersRoute =
  AdminSkidogTemplateTransfersRouteImport.update({
    id: '/template-transfers',
    path: '/template-transfers',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogStaffRoute = AdminSkidogStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogShowcaseRoute = AdminSkidogShowcaseRouteImport.update({
  id: '/showcase',
  path: '/showcase',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogSam3PlaygroundRoute =
  AdminSkidogSam3PlaygroundRouteImport.update({
    id: '/sam3-playground',
    path: '/sam3-playground',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogPlansRoute = AdminSkidogPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogOrganizationsRoute =
  AdminSkidogOrganizationsRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogIntegrationTasksRoute =
  AdminSkidogIntegrationTasksRouteImport.update({
    id: '/integration-tasks',
    path: '/integration-tasks',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogFeatureFlagsRoute = AdminSkidogFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogEmailDocumentsRoute =
  AdminSkidogEmailDocumentsRouteImport.update({
    id: '/email-documents',
    path: '/email-documents',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogDashboardRoute = AdminSkidogDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogCapacityRoute = AdminSkidogCapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogBgRemovalRoute = AdminSkidogBgRemovalRouteImport.update({
  id: '/bg-removal',
  path: '/bg-removal',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AdminSkidogAiCostsRoute = AdminSkidogAiCostsRouteImport.update({
  id: '/ai-costs',
  path: '/ai-costs',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AcceptInvitationTokenRoute = AcceptInvitationTokenRouteImport.update({
  id: '/accept-invitation/$token',
  path: '/accept-invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AdminSkidogWhiteGloveIndexRoute =
  AdminSkidogWhiteGloveIndexRouteImport.update({
    id: '/white-glove/',
    path: '/white-glove/',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogEmailArchiveIndexRoute =
  AdminSkidogEmailArchiveIndexRouteImport.update({
    id: '/email-archive/',
    path: '/email-archive/',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogDesignInspirationsIndexRoute =
  AdminSkidogDesignInspirationsIndexRouteImport.update({
    id: '/design-inspirations/',
    path: '/design-inspirations/',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogOrgIdIndexRoute = AdminSkidogOrgIdIndexRouteImport.update({
  id: '/$orgId/',
  path: '/$orgId/',
  getParentRoute: () => AdminSkidogRouteRoute,
} as any)
const AuthedDashboardIndexRoute = AuthedDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedDashboardRoute,
} as any)
const WTicketsTicketIdRoute = WTicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => WRouteRoute,
} as any)
const WBrandReviewsReviewIdRoute = WBrandReviewsReviewIdRouteImport.update({
  id: '/brand-reviews/$reviewId',
  path: '/brand-reviews/$reviewId',
  getParentRoute: () => WRouteRoute,
} as any)
const ClientTransfersClaimTokenRoute =
  ClientTransfersClaimTokenRouteImport.update({
    id: '/client-transfers/claim/$token',
    path: '/client-transfers/claim/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminSkidogWhiteGloveEngagementIdRoute =
  AdminSkidogWhiteGloveEngagementIdRouteImport.update({
    id: '/white-glove/$engagementId',
    path: '/white-glove/$engagementId',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogEmailDocumentTemplatesIdRoute =
  AdminSkidogEmailDocumentTemplatesIdRouteImport.update({
    id: '/email-document-templates/$id',
    path: '/email-document-templates/$id',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AdminSkidogEmailDocumentSectionsIdRoute =
  AdminSkidogEmailDocumentSectionsIdRouteImport.update({
    id: '/email-document-sections/$id',
    path: '/email-document-sections/$id',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AuthedDashboardNotificationsRoute =
  AuthedDashboardNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedIntegrationsKlaviyoIndexRoute =
  AuthedIntegrationsKlaviyoIndexRouteImport.update({
    id: '/integrations/klaviyo/',
    path: '/integrations/klaviyo/',
    getParentRoute: () => AuthedRoute,
  } as any)
const WTicketsTicketIdLiveRoute = WTicketsTicketIdLiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => WTicketsTicketIdRoute,
} as any)
const AdminSkidogOrgIdClientsClientIdRoute =
  AdminSkidogOrgIdClientsClientIdRouteImport.update({
    id: '/$orgId/clients/$clientId',
    path: '/$orgId/clients/$clientId',
    getParentRoute: () => AdminSkidogRouteRoute,
  } as any)
const AuthedIntegrationsKlaviyoInstallRoute =
  AuthedIntegrationsKlaviyoInstallRouteImport.update({
    id: '/integrations/klaviyo/install',
    path: '/integrations/klaviyo/install',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedIntegrationsKlaviyoCallbackRoute =
  AuthedIntegrationsKlaviyoCallbackRouteImport.update({
    id: '/integrations/klaviyo/callback',
    path: '/integrations/klaviyo/callback',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardTestCanvaskitRoute =
  AuthedDashboardTestCanvaskitRouteImport.update({
    id: '/test/canvaskit',
    path: '/test/canvaskit',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardTestCanvasPreviewRoute =
  AuthedDashboardTestCanvasPreviewRouteImport.update({
    id: '/test/canvas-preview',
    path: '/test/canvas-preview',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardOOrgIdRouteRoute =
  AuthedDashboardOOrgIdRouteRouteImport.update({
    id: '/o/$orgId',
    path: '/o/$orgId',
    getParentRoute: () => AuthedDashboardRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsRoute =
  AuthedDashboardOOrgIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedDashboardOOrgIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdClientsRoute =
  AuthedDashboardOOrgIdClientsRouteImport.update({
    id: '/clients',
    path: '/clients',
    getParentRoute: () => AuthedDashboardOOrgIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdWhiteGloveIndexRoute =
  AuthedDashboardOOrgIdWhiteGloveIndexRouteImport.update({
    id: '/white-glove/',
    path: '/white-glove/',
    getParentRoute: () => AuthedDashboardOOrgIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsIndexRoute =
  AuthedDashboardOOrgIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute =
  AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRouteImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => AdminSkidogOrgIdClientsClientIdRoute,
  } as any)
const AuthedDashboardOOrgIdWhiteGloveTasksRoute =
  AuthedDashboardOOrgIdWhiteGloveTasksRouteImport.update({
    id: '/white-glove/tasks',
    path: '/white-glove/tasks',
    getParentRoute: () => AuthedDashboardOOrgIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsProfileRoute =
  AuthedDashboardOOrgIdSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsAccountRoute =
  AuthedDashboardOOrgIdSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdRouteRoute =
  AuthedDashboardOOrgIdCClientIdRouteRouteImport.update({
    id: '/c/$clientId',
    path: '/c/$clientId',
    getParentRoute: () => AuthedDashboardOOrgIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsProfileIndexRoute =
  AuthedDashboardOOrgIdSettingsProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsProfileRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdIndexRoute =
  AuthedDashboardOOrgIdCClientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsOrganizationTeamRoute =
  AuthedDashboardOOrgIdSettingsOrganizationTeamRouteImport.update({
    id: '/organization/team',
    path: '/organization/team',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute =
  AuthedDashboardOOrgIdSettingsOrganizationGeneralRouteImport.update({
    id: '/organization/general',
    path: '/organization/general',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsOrganizationClientsRoute =
  AuthedDashboardOOrgIdSettingsOrganizationClientsRouteImport.update({
    id: '/organization/clients',
    path: '/organization/clients',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsOrganizationBillingRoute =
  AuthedDashboardOOrgIdSettingsOrganizationBillingRouteImport.update({
    id: '/organization/billing',
    path: '/organization/billing',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsOrganizationApiRoute =
  AuthedDashboardOOrgIdSettingsOrganizationApiRouteImport.update({
    id: '/organization/api',
    path: '/organization/api',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute =
  AuthedDashboardOOrgIdSettingsIntegrationsShopifyRouteImport.update({
    id: '/integrations/shopify',
    path: '/integrations/shopify',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute =
  AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRouteImport.update({
    id: '/integrations/mailchimp',
    path: '/integrations/mailchimp',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute =
  AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRouteImport.update({
    id: '/integrations/klaviyo',
    path: '/integrations/klaviyo',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute =
  AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRouteImport.update({
    id: '/integrations/google-drive',
    path: '/integrations/google-drive',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientIntegrationsRoute =
  AuthedDashboardOOrgIdSettingsClientIntegrationsRouteImport.update({
    id: '/client/integrations',
    path: '/client/integrations',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandRoute =
  AuthedDashboardOOrgIdSettingsClientBrandRouteImport.update({
    id: '/client/brand',
    path: '/client/brand',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute =
  AuthedDashboardOOrgIdCClientIdEmailImgUploadRouteImport.update({
    id: '/email-img-upload',
    path: '/email-img-upload',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdCreateRoute =
  AuthedDashboardOOrgIdCClientIdCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdContentBlocksRoute =
  AuthedDashboardOOrgIdCClientIdContentBlocksRouteImport.update({
    id: '/content-blocks',
    path: '/content-blocks',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAuditRoute =
  AuthedDashboardOOrgIdCClientIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteImport.update({
    id: '/white-glove',
    path: '/white-glove',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute =
  AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandIndexRoute =
  AuthedDashboardOOrgIdSettingsClientBrandIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsClientBrandRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute =
  AuthedDashboardOOrgIdCClientIdTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdSectionsIndexRoute =
  AuthedDashboardOOrgIdCClientIdSectionsIndexRouteImport.update({
    id: '/sections/',
    path: '/sections/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute =
  AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRouteImport.update({
    id: '/media-library/',
    path: '/media-library/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdInspoIndexRoute =
  AuthedDashboardOOrgIdCClientIdInspoIndexRouteImport.update({
    id: '/inspo/',
    path: '/inspo/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute =
  AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRouteImport.update({
    id: '/image-generator/',
    path: '/image-generator/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdFlowsIndexRoute =
  AuthedDashboardOOrgIdCClientIdFlowsIndexRouteImport.update({
    id: '/flows/',
    path: '/flows/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdCalendarIndexRoute =
  AuthedDashboardOOrgIdCClientIdCalendarIndexRouteImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdSectionsIdRoute =
  AuthedDashboardOOrgIdCClientIdSectionsIdRouteImport.update({
    id: '/dashboard_/o/$orgId/c/$clientId/sections/$id',
    path: '/dashboard/o/$orgId/c/$clientId/sections/$id',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdFlowsCreateRoute =
  AuthedDashboardOOrgIdCClientIdFlowsCreateRouteImport.update({
    id: '/dashboard_/o/$orgId/c/$clientId/flows/create',
    path: '/dashboard/o/$orgId/c/$clientId/flows/create',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdFlowsFlowIdRoute =
  AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteImport.update({
    id: '/dashboard_/o/$orgId/c/$clientId/flows/$flowId',
    path: '/dashboard/o/$orgId/c/$clientId/flows/$flowId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute =
  AuthedDashboardOOrgIdSettingsClientBrandProfilesRouteImport.update({
    id: '/profiles',
    path: '/profiles',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsClientBrandRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute =
  AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsClientBrandRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsClientBrandRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveTryRouteImport.update({
    id: '/try',
    path: '/try',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRouteImport.update({
    id: '/month',
    path: '/month',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRouteImport.update({
    id: '/intake',
    path: '/intake',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRouteImport.update({
    id: '/header',
    path: '/header',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRouteImport.update({
    id: '/footer',
    path: '/footer',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRouteImport.update({
    id: '/briefs',
    path: '/briefs',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdTemplatesMyRoute =
  AuthedDashboardOOrgIdCClientIdTemplatesMyRouteImport.update({
    id: '/my',
    path: '/my',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute =
  AuthedDashboardOOrgIdCClientIdTemplatesLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute =
  AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRouteImport.update({
    id: '/sms/$smsMessageId',
    path: '/sms/$smsMessageId',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdEmailsNewRoute =
  AuthedDashboardOOrgIdCClientIdEmailsNewRouteImport.update({
    id: '/emails/new',
    path: '/emails/new',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdEmailsCreateRoute =
  AuthedDashboardOOrgIdCClientIdEmailsCreateRouteImport.update({
    id: '/emails/create',
    path: '/emails/create',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRouteImport.update({
    id: '/revenue',
    path: '/revenue',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRouteImport.update({
    id: '/list-growth',
    path: '/list-growth',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRouteImport.update({
    id: '/flows',
    path: '/flows',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute =
  AuthedDashboardOOrgIdCClientIdAnalyticsAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute =
  AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdFlowsFlowIdRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute =
  AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRouteImport.update({
    id: '/dashboard_/o/$orgId/c/$clientId/emails/$templateId/edit',
    path: '/dashboard/o/$orgId/c/$clientId/emails/$templateId/edit',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute =
  AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRouteImport.update({
    id: '/dashboard_/o/$orgId/c/$clientId/emails/$templateId/chat',
    path: '/dashboard/o/$orgId/c/$clientId/emails/$templateId/chat',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRouteImport.update(
    {
      id: '/page-imports',
      path: '/page-imports',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRouteImport.update({
    id: '/knowledge',
    path: '/knowledge',
    getParentRoute: () => AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteImport.update({
    id: '/tickets/$ticketId',
    path: '/tickets/$ticketId',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRouteImport.update({
    id: '/review/$ticketId',
    path: '/review/$ticketId',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute =
  AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRouteImport.update({
    id: '/media-library/canvas/$canvasId',
    path: '/media-library/canvas/$canvasId',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute =
  AuthedDashboardOOrgIdCClientIdInspoListsListIdRouteImport.update({
    id: '/inspo/lists/$listId',
    path: '/inspo/lists/$listId',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute =
  AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRouteImport.update({
    id: '/inspo/brands/$slug',
    path: '/inspo/brands/$slug',
    getParentRoute: () => AuthedDashboardOOrgIdCClientIdRouteRoute,
  } as any)
const AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRouteImport.update(
    {
      id: '/products/',
      path: '/products/',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRouteImport.update(
    {
      id: '/integrations/',
      path: '/integrations/',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRouteImport.update(
    {
      id: '/integrations/woocommerce',
      path: '/integrations/woocommerce',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRouteImport.update(
    {
      id: '/integrations/shopify',
      path: '/integrations/shopify',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRouteImport.update(
    {
      id: '/integrations/omnisend',
      path: '/integrations/omnisend',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRouteImport.update(
    {
      id: '/integrations/mailchimp',
      path: '/integrations/mailchimp',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRouteImport.update(
    {
      id: '/integrations/klaviyo',
      path: '/integrations/klaviyo',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRouteImport.update(
    {
      id: '/integrations/hubspot',
      path: '/integrations/hubspot',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRouteImport.update(
    {
      id: '/integrations/google-drive',
      path: '/integrations/google-drive',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRouteImport.update(
    {
      id: '/integrations/figma',
      path: '/integrations/figma',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRouteImport.update(
    {
      id: '/integrations/dropbox',
      path: '/integrations/dropbox',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRouteImport.update(
    {
      id: '/integrations/constant-contact',
      path: '/integrations/constant-contact',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRouteImport.update(
    {
      id: '/integrations/campaigner',
      path: '/integrations/campaigner',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRouteImport.update(
    {
      id: '/integrations/campaign-monitor',
      path: '/integrations/campaign-monitor',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRouteImport.update(
    {
      id: '/integrations/brevo',
      path: '/integrations/brevo',
      getParentRoute: () =>
        AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute,
    } as any,
  )
const AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute =
  AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRouteImport.update(
    {
      id: '/review',
      path: '/review',
      getParentRoute: () =>
        AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin-skidog': typeof AdminSkidogRouteRouteWithChildren
  '/w': typeof WRouteRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/figma-auth': typeof FigmaAuthRoute
  '/onboarding': typeof OnboardingRoute
  '/test-svg': typeof TestSvgRoute
  '/dashboard': typeof AuthedDashboardRouteWithChildren
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/admin-skidog/ai-costs': typeof AdminSkidogAiCostsRoute
  '/admin-skidog/bg-removal': typeof AdminSkidogBgRemovalRoute
  '/admin-skidog/capacity': typeof AdminSkidogCapacityRoute
  '/admin-skidog/dashboard': typeof AdminSkidogDashboardRoute
  '/admin-skidog/email-documents': typeof AdminSkidogEmailDocumentsRoute
  '/admin-skidog/feature-flags': typeof AdminSkidogFeatureFlagsRoute
  '/admin-skidog/integration-tasks': typeof AdminSkidogIntegrationTasksRoute
  '/admin-skidog/organizations': typeof AdminSkidogOrganizationsRoute
  '/admin-skidog/plans': typeof AdminSkidogPlansRoute
  '/admin-skidog/sam3-playground': typeof AdminSkidogSam3PlaygroundRoute
  '/admin-skidog/showcase': typeof AdminSkidogShowcaseRoute
  '/admin-skidog/staff': typeof AdminSkidogStaffRoute
  '/admin-skidog/template-transfers': typeof AdminSkidogTemplateTransfersRoute
  '/admin-skidog/templates': typeof AdminSkidogTemplatesRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/p/$token': typeof PTokenRoute
  '/w/capacity': typeof WCapacityRoute
  '/w/notifications': typeof WNotificationsRoute
  '/w/queue': typeof WQueueRoute
  '/admin-skidog/': typeof AdminSkidogIndexRoute
  '/p/': typeof PIndexRoute
  '/w/': typeof WIndexRoute
  '/dashboard/notifications': typeof AuthedDashboardNotificationsRoute
  '/admin-skidog/email-document-sections/$id': typeof AdminSkidogEmailDocumentSectionsIdRoute
  '/admin-skidog/email-document-templates/$id': typeof AdminSkidogEmailDocumentTemplatesIdRoute
  '/admin-skidog/white-glove/$engagementId': typeof AdminSkidogWhiteGloveEngagementIdRoute
  '/client-transfers/claim/$token': typeof ClientTransfersClaimTokenRoute
  '/w/brand-reviews/$reviewId': typeof WBrandReviewsReviewIdRoute
  '/w/tickets/$ticketId': typeof WTicketsTicketIdRouteWithChildren
  '/dashboard/': typeof AuthedDashboardIndexRoute
  '/admin-skidog/$orgId/': typeof AdminSkidogOrgIdIndexRoute
  '/admin-skidog/design-inspirations/': typeof AdminSkidogDesignInspirationsIndexRoute
  '/admin-skidog/email-archive/': typeof AdminSkidogEmailArchiveIndexRoute
  '/admin-skidog/white-glove/': typeof AdminSkidogWhiteGloveIndexRoute
  '/dashboard/o/$orgId': typeof AuthedDashboardOOrgIdRouteRouteWithChildren
  '/dashboard/test/canvas-preview': typeof AuthedDashboardTestCanvasPreviewRoute
  '/dashboard/test/canvaskit': typeof AuthedDashboardTestCanvaskitRoute
  '/integrations/klaviyo/callback': typeof AuthedIntegrationsKlaviyoCallbackRoute
  '/integrations/klaviyo/install': typeof AuthedIntegrationsKlaviyoInstallRoute
  '/admin-skidog/$orgId/clients/$clientId': typeof AdminSkidogOrgIdClientsClientIdRouteWithChildren
  '/w/tickets/$ticketId/live': typeof WTicketsTicketIdLiveRoute
  '/integrations/klaviyo/': typeof AuthedIntegrationsKlaviyoIndexRoute
  '/dashboard/o/$orgId/clients': typeof AuthedDashboardOOrgIdClientsRoute
  '/dashboard/o/$orgId/settings': typeof AuthedDashboardOOrgIdSettingsRouteWithChildren
  '/dashboard/o/$orgId/c/$clientId': typeof AuthedDashboardOOrgIdCClientIdRouteRouteWithChildren
  '/dashboard/o/$orgId/settings/account': typeof AuthedDashboardOOrgIdSettingsAccountRoute
  '/dashboard/o/$orgId/settings/profile': typeof AuthedDashboardOOrgIdSettingsProfileRouteWithChildren
  '/dashboard/o/$orgId/white-glove/tasks': typeof AuthedDashboardOOrgIdWhiteGloveTasksRoute
  '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId': typeof AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute
  '/dashboard/o/$orgId/settings/': typeof AuthedDashboardOOrgIdSettingsIndexRoute
  '/dashboard/o/$orgId/white-glove/': typeof AuthedDashboardOOrgIdWhiteGloveIndexRoute
  '/dashboard/o/$orgId/c/$clientId/analytics': typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteWithChildren
  '/dashboard/o/$orgId/c/$clientId/templates': typeof AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteWithChildren
  '/dashboard/o/$orgId/c/$clientId/white-glove': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteWithChildren
  '/dashboard/o/$orgId/c/$clientId/audit': typeof AuthedDashboardOOrgIdCClientIdAuditRoute
  '/dashboard/o/$orgId/c/$clientId/content-blocks': typeof AuthedDashboardOOrgIdCClientIdContentBlocksRoute
  '/dashboard/o/$orgId/c/$clientId/create': typeof AuthedDashboardOOrgIdCClientIdCreateRoute
  '/dashboard/o/$orgId/c/$clientId/email-img-upload': typeof AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute
  '/dashboard/o/$orgId/settings/client/brand': typeof AuthedDashboardOOrgIdSettingsClientBrandRouteWithChildren
  '/dashboard/o/$orgId/settings/client/integrations': typeof AuthedDashboardOOrgIdSettingsClientIntegrationsRoute
  '/dashboard/o/$orgId/settings/integrations/google-drive': typeof AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute
  '/dashboard/o/$orgId/settings/integrations/klaviyo': typeof AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute
  '/dashboard/o/$orgId/settings/integrations/mailchimp': typeof AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute
  '/dashboard/o/$orgId/settings/integrations/shopify': typeof AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute
  '/dashboard/o/$orgId/settings/organization/api': typeof AuthedDashboardOOrgIdSettingsOrganizationApiRoute
  '/dashboard/o/$orgId/settings/organization/billing': typeof AuthedDashboardOOrgIdSettingsOrganizationBillingRoute
  '/dashboard/o/$orgId/settings/organization/clients': typeof AuthedDashboardOOrgIdSettingsOrganizationClientsRoute
  '/dashboard/o/$orgId/settings/organization/general': typeof AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute
  '/dashboard/o/$orgId/settings/organization/team': typeof AuthedDashboardOOrgIdSettingsOrganizationTeamRoute
  '/dashboard/o/$orgId/c/$clientId/': typeof AuthedDashboardOOrgIdCClientIdIndexRoute
  '/dashboard/o/$orgId/settings/profile/': typeof AuthedDashboardOOrgIdSettingsProfileIndexRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/audit': typeof AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/campaigns': typeof AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/flows': typeof AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/list-growth': typeof AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/orders': typeof AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/revenue': typeof AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute
  '/dashboard/o/$orgId/c/$clientId/emails/create': typeof AuthedDashboardOOrgIdCClientIdEmailsCreateRoute
  '/dashboard/o/$orgId/c/$clientId/emails/new': typeof AuthedDashboardOOrgIdCClientIdEmailsNewRoute
  '/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId': typeof AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute
  '/dashboard/o/$orgId/c/$clientId/templates/library': typeof AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute
  '/dashboard/o/$orgId/c/$clientId/templates/my': typeof AuthedDashboardOOrgIdCClientIdTemplatesMyRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/briefs': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/calendar': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/footer': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/header': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/intake': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/month': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/schedule': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/tasks': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/try': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteWithChildren
  '/dashboard/o/$orgId/settings/client/brand/integrations': typeof AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute
  '/dashboard/o/$orgId/settings/client/brand/profiles': typeof AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute
  '/dashboard/o/$orgId/c/$clientId/flows/$flowId': typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteWithChildren
  '/dashboard/o/$orgId/c/$clientId/flows/create': typeof AuthedDashboardOOrgIdCClientIdFlowsCreateRoute
  '/dashboard/o/$orgId/c/$clientId/sections/$id': typeof AuthedDashboardOOrgIdCClientIdSectionsIdRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/': typeof AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute
  '/dashboard/o/$orgId/c/$clientId/calendar/': typeof AuthedDashboardOOrgIdCClientIdCalendarIndexRoute
  '/dashboard/o/$orgId/c/$clientId/flows/': typeof AuthedDashboardOOrgIdCClientIdFlowsIndexRoute
  '/dashboard/o/$orgId/c/$clientId/image-generator/': typeof AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute
  '/dashboard/o/$orgId/c/$clientId/inspo/': typeof AuthedDashboardOOrgIdCClientIdInspoIndexRoute
  '/dashboard/o/$orgId/c/$clientId/media-library/': typeof AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute
  '/dashboard/o/$orgId/c/$clientId/sections/': typeof AuthedDashboardOOrgIdCClientIdSectionsIndexRoute
  '/dashboard/o/$orgId/c/$clientId/templates/': typeof AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute
  '/dashboard/o/$orgId/settings/client/brand/': typeof AuthedDashboardOOrgIdSettingsClientBrandIndexRoute
  '/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug': typeof AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute
  '/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId': typeof AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute
  '/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId': typeof AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteWithChildren
  '/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute
  '/dashboard/o/$orgId/c/$clientId/emails/$templateId/chat': typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute
  '/dashboard/o/$orgId/c/$clientId/emails/$templateId/edit': typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute
  '/dashboard/o/$orgId/c/$clientId/flows/$flowId/edit': typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/products/': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/figma-auth': typeof FigmaAuthRoute
  '/onboarding': typeof OnboardingRoute
  '/test-svg': typeof TestSvgRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/admin-skidog/ai-costs': typeof AdminSkidogAiCostsRoute
  '/admin-skidog/bg-removal': typeof AdminSkidogBgRemovalRoute
  '/admin-skidog/capacity': typeof AdminSkidogCapacityRoute
  '/admin-skidog/dashboard': typeof AdminSkidogDashboardRoute
  '/admin-skidog/email-documents': typeof AdminSkidogEmailDocumentsRoute
  '/admin-skidog/feature-flags': typeof AdminSkidogFeatureFlagsRoute
  '/admin-skidog/integration-tasks': typeof AdminSkidogIntegrationTasksRoute
  '/admin-skidog/organizations': typeof AdminSkidogOrganizationsRoute
  '/admin-skidog/plans': typeof AdminSkidogPlansRoute
  '/admin-skidog/sam3-playground': typeof AdminSkidogSam3PlaygroundRoute
  '/admin-skidog/showcase': typeof AdminSkidogShowcaseRoute
  '/admin-skidog/staff': typeof AdminSkidogStaffRoute
  '/admin-skidog/template-transfers': typeof AdminSkidogTemplateTransfersRoute
  '/admin-skidog/templates': typeof AdminSkidogTemplatesRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/p/$token': typeof PTokenRoute
  '/w/capacity': typeof WCapacityRoute
  '/w/notifications': typeof WNotificationsRoute
  '/w/queue': typeof WQueueRoute
  '/admin-skidog': typeof AdminSkidogIndexRoute
  '/p': typeof PIndexRoute
  '/w': typeof WIndexRoute
  '/dashboard/notifications': typeof AuthedDashboardNotificationsRoute
  '/admin-skidog/email-document-sections/$id': typeof AdminSkidogEmailDocumentSectionsIdRoute
  '/admin-skidog/email-document-templates/$id': typeof AdminSkidogEmailDocumentTemplatesIdRoute
  '/admin-skidog/white-glove/$engagementId': typeof AdminSkidogWhiteGloveEngagementIdRoute
  '/client-transfers/claim/$token': typeof ClientTransfersClaimTokenRoute
  '/w/brand-reviews/$reviewId': typeof WBrandReviewsReviewIdRoute
  '/w/tickets/$ticketId': typeof WTicketsTicketIdRouteWithChildren
  '/dashboard': typeof AuthedDashboardIndexRoute
  '/admin-skidog/$orgId': typeof AdminSkidogOrgIdIndexRoute
  '/admin-skidog/design-inspirations': typeof AdminSkidogDesignInspirationsIndexRoute
  '/admin-skidog/email-archive': typeof AdminSkidogEmailArchiveIndexRoute
  '/admin-skidog/white-glove': typeof AdminSkidogWhiteGloveIndexRoute
  '/dashboard/o/$orgId': typeof AuthedDashboardOOrgIdRouteRouteWithChildren
  '/dashboard/test/canvas-preview': typeof AuthedDashboardTestCanvasPreviewRoute
  '/dashboard/test/canvaskit': typeof AuthedDashboardTestCanvaskitRoute
  '/integrations/klaviyo/callback': typeof AuthedIntegrationsKlaviyoCallbackRoute
  '/integrations/klaviyo/install': typeof AuthedIntegrationsKlaviyoInstallRoute
  '/admin-skidog/$orgId/clients/$clientId': typeof AdminSkidogOrgIdClientsClientIdRouteWithChildren
  '/w/tickets/$ticketId/live': typeof WTicketsTicketIdLiveRoute
  '/integrations/klaviyo': typeof AuthedIntegrationsKlaviyoIndexRoute
  '/dashboard/o/$orgId/clients': typeof AuthedDashboardOOrgIdClientsRoute
  '/dashboard/o/$orgId/settings/account': typeof AuthedDashboardOOrgIdSettingsAccountRoute
  '/dashboard/o/$orgId/white-glove/tasks': typeof AuthedDashboardOOrgIdWhiteGloveTasksRoute
  '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId': typeof AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute
  '/dashboard/o/$orgId/settings': typeof AuthedDashboardOOrgIdSettingsIndexRoute
  '/dashboard/o/$orgId/white-glove': typeof AuthedDashboardOOrgIdWhiteGloveIndexRoute
  '/dashboard/o/$orgId/c/$clientId/audit': typeof AuthedDashboardOOrgIdCClientIdAuditRoute
  '/dashboard/o/$orgId/c/$clientId/content-blocks': typeof AuthedDashboardOOrgIdCClientIdContentBlocksRoute
  '/dashboard/o/$orgId/c/$clientId/create': typeof AuthedDashboardOOrgIdCClientIdCreateRoute
  '/dashboard/o/$orgId/c/$clientId/email-img-upload': typeof AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute
  '/dashboard/o/$orgId/settings/client/integrations': typeof AuthedDashboardOOrgIdSettingsClientIntegrationsRoute
  '/dashboard/o/$orgId/settings/integrations/google-drive': typeof AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute
  '/dashboard/o/$orgId/settings/integrations/klaviyo': typeof AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute
  '/dashboard/o/$orgId/settings/integrations/mailchimp': typeof AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute
  '/dashboard/o/$orgId/settings/integrations/shopify': typeof AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute
  '/dashboard/o/$orgId/settings/organization/api': typeof AuthedDashboardOOrgIdSettingsOrganizationApiRoute
  '/dashboard/o/$orgId/settings/organization/billing': typeof AuthedDashboardOOrgIdSettingsOrganizationBillingRoute
  '/dashboard/o/$orgId/settings/organization/clients': typeof AuthedDashboardOOrgIdSettingsOrganizationClientsRoute
  '/dashboard/o/$orgId/settings/organization/general': typeof AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute
  '/dashboard/o/$orgId/settings/organization/team': typeof AuthedDashboardOOrgIdSettingsOrganizationTeamRoute
  '/dashboard/o/$orgId/c/$clientId': typeof AuthedDashboardOOrgIdCClientIdIndexRoute
  '/dashboard/o/$orgId/settings/profile': typeof AuthedDashboardOOrgIdSettingsProfileIndexRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/audit': typeof AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/campaigns': typeof AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/flows': typeof AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/list-growth': typeof AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/orders': typeof AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute
  '/dashboard/o/$orgId/c/$clientId/analytics/revenue': typeof AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute
  '/dashboard/o/$orgId/c/$clientId/emails/create': typeof AuthedDashboardOOrgIdCClientIdEmailsCreateRoute
  '/dashboard/o/$orgId/c/$clientId/emails/new': typeof AuthedDashboardOOrgIdCClientIdEmailsNewRoute
  '/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId': typeof AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute
  '/dashboard/o/$orgId/c/$clientId/templates/library': typeof AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute
  '/dashboard/o/$orgId/c/$clientId/templates/my': typeof AuthedDashboardOOrgIdCClientIdTemplatesMyRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/briefs': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/calendar': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/footer': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/header': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/intake': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/month': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/schedule': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/tasks': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/try': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute
  '/dashboard/o/$orgId/settings/client/brand/integrations': typeof AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute
  '/dashboard/o/$orgId/settings/client/brand/profiles': typeof AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute
  '/dashboard/o/$orgId/c/$clientId/flows/$flowId': typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteWithChildren
  '/dashboard/o/$orgId/c/$clientId/flows/create': typeof AuthedDashboardOOrgIdCClientIdFlowsCreateRoute
  '/dashboard/o/$orgId/c/$clientId/sections/$id': typeof AuthedDashboardOOrgIdCClientIdSectionsIdRoute
  '/dashboard/o/$orgId/c/$clientId/analytics': typeof AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute
  '/dashboard/o/$orgId/c/$clientId/calendar': typeof AuthedDashboardOOrgIdCClientIdCalendarIndexRoute
  '/dashboard/o/$orgId/c/$clientId/flows': typeof AuthedDashboardOOrgIdCClientIdFlowsIndexRoute
  '/dashboard/o/$orgId/c/$clientId/image-generator': typeof AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute
  '/dashboard/o/$orgId/c/$clientId/inspo': typeof AuthedDashboardOOrgIdCClientIdInspoIndexRoute
  '/dashboard/o/$orgId/c/$clientId/media-library': typeof AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute
  '/dashboard/o/$orgId/c/$clientId/sections': typeof AuthedDashboardOOrgIdCClientIdSectionsIndexRoute
  '/dashboard/o/$orgId/c/$clientId/templates': typeof AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute
  '/dashboard/o/$orgId/settings/client/brand': typeof AuthedDashboardOOrgIdSettingsClientBrandIndexRoute
  '/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug': typeof AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute
  '/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId': typeof AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute
  '/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId': typeof AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteWithChildren
  '/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute
  '/dashboard/o/$orgId/c/$clientId/emails/$templateId/chat': typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute
  '/dashboard/o/$orgId/c/$clientId/emails/$templateId/edit': typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute
  '/dashboard/o/$orgId/c/$clientId/flows/$flowId/edit': typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute
  '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute
  '/dashboard/o/$orgId/settings/client/brand/$clientId/products': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin-skidog': typeof AdminSkidogRouteRouteWithChildren
  '/w': typeof WRouteRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/figma-auth': typeof FigmaAuthRoute
  '/onboarding': typeof OnboardingRoute
  '/test-svg': typeof TestSvgRoute
  '/_authed/dashboard': typeof AuthedDashboardRouteWithChildren
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/admin-skidog/ai-costs': typeof AdminSkidogAiCostsRoute
  '/admin-skidog/bg-removal': typeof AdminSkidogBgRemovalRoute
  '/admin-skidog/capacity': typeof AdminSkidogCapacityRoute
  '/admin-skidog/dashboard': typeof AdminSkidogDashboardRoute
  '/admin-skidog/email-documents': typeof AdminSkidogEmailDocumentsRoute
  '/admin-skidog/feature-flags': typeof AdminSkidogFeatureFlagsRoute
  '/admin-skidog/integration-tasks': typeof AdminSkidogIntegrationTasksRoute
  '/admin-skidog/organizations': typeof AdminSkidogOrganizationsRoute
  '/admin-skidog/plans': typeof AdminSkidogPlansRoute
  '/admin-skidog/sam3-playground': typeof AdminSkidogSam3PlaygroundRoute
  '/admin-skidog/showcase': typeof AdminSkidogShowcaseRoute
  '/admin-skidog/staff': typeof AdminSkidogStaffRoute
  '/admin-skidog/template-transfers': typeof AdminSkidogTemplateTransfersRoute
  '/admin-skidog/templates': typeof AdminSkidogTemplatesRoute
  '/auth/confirm': typeof AuthConfirmRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/p/$token': typeof PTokenRoute
  '/w/capacity': typeof WCapacityRoute
  '/w/notifications': typeof WNotificationsRoute
  '/w/queue': typeof WQueueRoute
  '/admin-skidog/': typeof AdminSkidogIndexRoute
  '/p/': typeof PIndexRoute
  '/w/': typeof WIndexRoute
  '/_authed/dashboard/notifications': typeof AuthedDashboardNotificationsRoute
  '/admin-skidog/email-document-sections/$id': typeof AdminSkidogEmailDocumentSectionsIdRoute
  '/admin-skidog/email-document-templates/$id': typeof AdminSkidogEmailDocumentTemplatesIdRoute
  '/admin-skidog/white-glove/$engagementId': typeof AdminSkidogWhiteGloveEngagementIdRoute
  '/client-transfers/claim/$token': typeof ClientTransfersClaimTokenRoute
  '/w/brand-reviews/$reviewId': typeof WBrandReviewsReviewIdRoute
  '/w/tickets/$ticketId': typeof WTicketsTicketIdRouteWithChildren
  '/_authed/dashboard/': typeof AuthedDashboardIndexRoute
  '/admin-skidog/$orgId/': typeof AdminSkidogOrgIdIndexRoute
  '/admin-skidog/design-inspirations/': typeof AdminSkidogDesignInspirationsIndexRoute
  '/admin-skidog/email-archive/': typeof AdminSkidogEmailArchiveIndexRoute
  '/admin-skidog/white-glove/': typeof AdminSkidogWhiteGloveIndexRoute
  '/_authed/dashboard/o/$orgId': typeof AuthedDashboardOOrgIdRouteRouteWithChildren
  '/_authed/dashboard/test/canvas-preview': typeof AuthedDashboardTestCanvasPreviewRoute
  '/_authed/dashboard/test/canvaskit': typeof AuthedDashboardTestCanvaskitRoute
  '/_authed/integrations/klaviyo/callback': typeof AuthedIntegrationsKlaviyoCallbackRoute
  '/_authed/integrations/klaviyo/install': typeof AuthedIntegrationsKlaviyoInstallRoute
  '/admin-skidog/$orgId/clients/$clientId': typeof AdminSkidogOrgIdClientsClientIdRouteWithChildren
  '/w/tickets/$ticketId/live': typeof WTicketsTicketIdLiveRoute
  '/_authed/integrations/klaviyo/': typeof AuthedIntegrationsKlaviyoIndexRoute
  '/_authed/dashboard/o/$orgId/clients': typeof AuthedDashboardOOrgIdClientsRoute
  '/_authed/dashboard/o/$orgId/settings': typeof AuthedDashboardOOrgIdSettingsRouteWithChildren
  '/_authed/dashboard/o/$orgId/c/$clientId': typeof AuthedDashboardOOrgIdCClientIdRouteRouteWithChildren
  '/_authed/dashboard/o/$orgId/settings/account': typeof AuthedDashboardOOrgIdSettingsAccountRoute
  '/_authed/dashboard/o/$orgId/settings/profile': typeof AuthedDashboardOOrgIdSettingsProfileRouteWithChildren
  '/_authed/dashboard/o/$orgId/white-glove/tasks': typeof AuthedDashboardOOrgIdWhiteGloveTasksRoute
  '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId': typeof AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute
  '/_authed/dashboard/o/$orgId/settings/': typeof AuthedDashboardOOrgIdSettingsIndexRoute
  '/_authed/dashboard/o/$orgId/white-glove/': typeof AuthedDashboardOOrgIdWhiteGloveIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics': typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteWithChildren
  '/_authed/dashboard/o/$orgId/c/$clientId/templates': typeof AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteWithChildren
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteWithChildren
  '/_authed/dashboard/o/$orgId/c/$clientId/audit': typeof AuthedDashboardOOrgIdCClientIdAuditRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/content-blocks': typeof AuthedDashboardOOrgIdCClientIdContentBlocksRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/create': typeof AuthedDashboardOOrgIdCClientIdCreateRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/email-img-upload': typeof AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand': typeof AuthedDashboardOOrgIdSettingsClientBrandRouteWithChildren
  '/_authed/dashboard/o/$orgId/settings/client/integrations': typeof AuthedDashboardOOrgIdSettingsClientIntegrationsRoute
  '/_authed/dashboard/o/$orgId/settings/integrations/google-drive': typeof AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute
  '/_authed/dashboard/o/$orgId/settings/integrations/klaviyo': typeof AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute
  '/_authed/dashboard/o/$orgId/settings/integrations/mailchimp': typeof AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute
  '/_authed/dashboard/o/$orgId/settings/integrations/shopify': typeof AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute
  '/_authed/dashboard/o/$orgId/settings/organization/api': typeof AuthedDashboardOOrgIdSettingsOrganizationApiRoute
  '/_authed/dashboard/o/$orgId/settings/organization/billing': typeof AuthedDashboardOOrgIdSettingsOrganizationBillingRoute
  '/_authed/dashboard/o/$orgId/settings/organization/clients': typeof AuthedDashboardOOrgIdSettingsOrganizationClientsRoute
  '/_authed/dashboard/o/$orgId/settings/organization/general': typeof AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute
  '/_authed/dashboard/o/$orgId/settings/organization/team': typeof AuthedDashboardOOrgIdSettingsOrganizationTeamRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/': typeof AuthedDashboardOOrgIdCClientIdIndexRoute
  '/_authed/dashboard/o/$orgId/settings/profile/': typeof AuthedDashboardOOrgIdSettingsProfileIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/audit': typeof AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/campaigns': typeof AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/flows': typeof AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/list-growth': typeof AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/orders': typeof AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/revenue': typeof AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/emails/create': typeof AuthedDashboardOOrgIdCClientIdEmailsCreateRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/emails/new': typeof AuthedDashboardOOrgIdCClientIdEmailsNewRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId': typeof AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/templates/library': typeof AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/templates/my': typeof AuthedDashboardOOrgIdCClientIdTemplatesMyRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/briefs': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/calendar': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/footer': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/header': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/intake': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/month': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/schedule': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tasks': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/try': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteWithChildren
  '/_authed/dashboard/o/$orgId/settings/client/brand/integrations': typeof AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/profiles': typeof AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute
  '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId': typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteWithChildren
  '/_authed/dashboard_/o/$orgId/c/$clientId/flows/create': typeof AuthedDashboardOOrgIdCClientIdFlowsCreateRoute
  '/_authed/dashboard_/o/$orgId/c/$clientId/sections/$id': typeof AuthedDashboardOOrgIdCClientIdSectionsIdRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/analytics/': typeof AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/calendar/': typeof AuthedDashboardOOrgIdCClientIdCalendarIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/flows/': typeof AuthedDashboardOOrgIdCClientIdFlowsIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/image-generator/': typeof AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/inspo/': typeof AuthedDashboardOOrgIdCClientIdInspoIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/media-library/': typeof AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/sections/': typeof AuthedDashboardOOrgIdCClientIdSectionsIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/templates/': typeof AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/': typeof AuthedDashboardOOrgIdSettingsClientBrandIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug': typeof AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId': typeof AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId': typeof AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteWithChildren
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute
  '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/chat': typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute
  '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/edit': typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute
  '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId/edit': typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute
  '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review': typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute
  '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/products/': typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin-skidog'
    | '/w'
    | '/auth'
    | '/figma-auth'
    | '/onboarding'
    | '/test-svg'
    | '/dashboard'
    | '/accept-invitation/$token'
    | '/admin-skidog/ai-costs'
    | '/admin-skidog/bg-removal'
    | '/admin-skidog/capacity'
    | '/admin-skidog/dashboard'
    | '/admin-skidog/email-documents'
    | '/admin-skidog/feature-flags'
    | '/admin-skidog/integration-tasks'
    | '/admin-skidog/organizations'
    | '/admin-skidog/plans'
    | '/admin-skidog/sam3-playground'
    | '/admin-skidog/showcase'
    | '/admin-skidog/staff'
    | '/admin-skidog/template-transfers'
    | '/admin-skidog/templates'
    | '/auth/confirm'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/p/$token'
    | '/w/capacity'
    | '/w/notifications'
    | '/w/queue'
    | '/admin-skidog/'
    | '/p/'
    | '/w/'
    | '/dashboard/notifications'
    | '/admin-skidog/email-document-sections/$id'
    | '/admin-skidog/email-document-templates/$id'
    | '/admin-skidog/white-glove/$engagementId'
    | '/client-transfers/claim/$token'
    | '/w/brand-reviews/$reviewId'
    | '/w/tickets/$ticketId'
    | '/dashboard/'
    | '/admin-skidog/$orgId/'
    | '/admin-skidog/design-inspirations/'
    | '/admin-skidog/email-archive/'
    | '/admin-skidog/white-glove/'
    | '/dashboard/o/$orgId'
    | '/dashboard/test/canvas-preview'
    | '/dashboard/test/canvaskit'
    | '/integrations/klaviyo/callback'
    | '/integrations/klaviyo/install'
    | '/admin-skidog/$orgId/clients/$clientId'
    | '/w/tickets/$ticketId/live'
    | '/integrations/klaviyo/'
    | '/dashboard/o/$orgId/clients'
    | '/dashboard/o/$orgId/settings'
    | '/dashboard/o/$orgId/c/$clientId'
    | '/dashboard/o/$orgId/settings/account'
    | '/dashboard/o/$orgId/settings/profile'
    | '/dashboard/o/$orgId/white-glove/tasks'
    | '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId'
    | '/dashboard/o/$orgId/settings/'
    | '/dashboard/o/$orgId/white-glove/'
    | '/dashboard/o/$orgId/c/$clientId/analytics'
    | '/dashboard/o/$orgId/c/$clientId/templates'
    | '/dashboard/o/$orgId/c/$clientId/white-glove'
    | '/dashboard/o/$orgId/c/$clientId/audit'
    | '/dashboard/o/$orgId/c/$clientId/content-blocks'
    | '/dashboard/o/$orgId/c/$clientId/create'
    | '/dashboard/o/$orgId/c/$clientId/email-img-upload'
    | '/dashboard/o/$orgId/settings/client/brand'
    | '/dashboard/o/$orgId/settings/client/integrations'
    | '/dashboard/o/$orgId/settings/integrations/google-drive'
    | '/dashboard/o/$orgId/settings/integrations/klaviyo'
    | '/dashboard/o/$orgId/settings/integrations/mailchimp'
    | '/dashboard/o/$orgId/settings/integrations/shopify'
    | '/dashboard/o/$orgId/settings/organization/api'
    | '/dashboard/o/$orgId/settings/organization/billing'
    | '/dashboard/o/$orgId/settings/organization/clients'
    | '/dashboard/o/$orgId/settings/organization/general'
    | '/dashboard/o/$orgId/settings/organization/team'
    | '/dashboard/o/$orgId/c/$clientId/'
    | '/dashboard/o/$orgId/settings/profile/'
    | '/dashboard/o/$orgId/c/$clientId/analytics/audit'
    | '/dashboard/o/$orgId/c/$clientId/analytics/campaigns'
    | '/dashboard/o/$orgId/c/$clientId/analytics/flows'
    | '/dashboard/o/$orgId/c/$clientId/analytics/list-growth'
    | '/dashboard/o/$orgId/c/$clientId/analytics/orders'
    | '/dashboard/o/$orgId/c/$clientId/analytics/revenue'
    | '/dashboard/o/$orgId/c/$clientId/emails/create'
    | '/dashboard/o/$orgId/c/$clientId/emails/new'
    | '/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId'
    | '/dashboard/o/$orgId/c/$clientId/templates/library'
    | '/dashboard/o/$orgId/c/$clientId/templates/my'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/briefs'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/calendar'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/footer'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/header'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/intake'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/month'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/schedule'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/tasks'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/try'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId'
    | '/dashboard/o/$orgId/settings/client/brand/integrations'
    | '/dashboard/o/$orgId/settings/client/brand/profiles'
    | '/dashboard/o/$orgId/c/$clientId/flows/$flowId'
    | '/dashboard/o/$orgId/c/$clientId/flows/create'
    | '/dashboard/o/$orgId/c/$clientId/sections/$id'
    | '/dashboard/o/$orgId/c/$clientId/analytics/'
    | '/dashboard/o/$orgId/c/$clientId/calendar/'
    | '/dashboard/o/$orgId/c/$clientId/flows/'
    | '/dashboard/o/$orgId/c/$clientId/image-generator/'
    | '/dashboard/o/$orgId/c/$clientId/inspo/'
    | '/dashboard/o/$orgId/c/$clientId/media-library/'
    | '/dashboard/o/$orgId/c/$clientId/sections/'
    | '/dashboard/o/$orgId/c/$clientId/templates/'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/'
    | '/dashboard/o/$orgId/settings/client/brand/'
    | '/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug'
    | '/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId'
    | '/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports'
    | '/dashboard/o/$orgId/c/$clientId/emails/$templateId/chat'
    | '/dashboard/o/$orgId/c/$clientId/emails/$templateId/edit'
    | '/dashboard/o/$orgId/c/$clientId/flows/$flowId/edit'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/products/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/figma-auth'
    | '/onboarding'
    | '/test-svg'
    | '/accept-invitation/$token'
    | '/admin-skidog/ai-costs'
    | '/admin-skidog/bg-removal'
    | '/admin-skidog/capacity'
    | '/admin-skidog/dashboard'
    | '/admin-skidog/email-documents'
    | '/admin-skidog/feature-flags'
    | '/admin-skidog/integration-tasks'
    | '/admin-skidog/organizations'
    | '/admin-skidog/plans'
    | '/admin-skidog/sam3-playground'
    | '/admin-skidog/showcase'
    | '/admin-skidog/staff'
    | '/admin-skidog/template-transfers'
    | '/admin-skidog/templates'
    | '/auth/confirm'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/p/$token'
    | '/w/capacity'
    | '/w/notifications'
    | '/w/queue'
    | '/admin-skidog'
    | '/p'
    | '/w'
    | '/dashboard/notifications'
    | '/admin-skidog/email-document-sections/$id'
    | '/admin-skidog/email-document-templates/$id'
    | '/admin-skidog/white-glove/$engagementId'
    | '/client-transfers/claim/$token'
    | '/w/brand-reviews/$reviewId'
    | '/w/tickets/$ticketId'
    | '/dashboard'
    | '/admin-skidog/$orgId'
    | '/admin-skidog/design-inspirations'
    | '/admin-skidog/email-archive'
    | '/admin-skidog/white-glove'
    | '/dashboard/o/$orgId'
    | '/dashboard/test/canvas-preview'
    | '/dashboard/test/canvaskit'
    | '/integrations/klaviyo/callback'
    | '/integrations/klaviyo/install'
    | '/admin-skidog/$orgId/clients/$clientId'
    | '/w/tickets/$ticketId/live'
    | '/integrations/klaviyo'
    | '/dashboard/o/$orgId/clients'
    | '/dashboard/o/$orgId/settings/account'
    | '/dashboard/o/$orgId/white-glove/tasks'
    | '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId'
    | '/dashboard/o/$orgId/settings'
    | '/dashboard/o/$orgId/white-glove'
    | '/dashboard/o/$orgId/c/$clientId/audit'
    | '/dashboard/o/$orgId/c/$clientId/content-blocks'
    | '/dashboard/o/$orgId/c/$clientId/create'
    | '/dashboard/o/$orgId/c/$clientId/email-img-upload'
    | '/dashboard/o/$orgId/settings/client/integrations'
    | '/dashboard/o/$orgId/settings/integrations/google-drive'
    | '/dashboard/o/$orgId/settings/integrations/klaviyo'
    | '/dashboard/o/$orgId/settings/integrations/mailchimp'
    | '/dashboard/o/$orgId/settings/integrations/shopify'
    | '/dashboard/o/$orgId/settings/organization/api'
    | '/dashboard/o/$orgId/settings/organization/billing'
    | '/dashboard/o/$orgId/settings/organization/clients'
    | '/dashboard/o/$orgId/settings/organization/general'
    | '/dashboard/o/$orgId/settings/organization/team'
    | '/dashboard/o/$orgId/c/$clientId'
    | '/dashboard/o/$orgId/settings/profile'
    | '/dashboard/o/$orgId/c/$clientId/analytics/audit'
    | '/dashboard/o/$orgId/c/$clientId/analytics/campaigns'
    | '/dashboard/o/$orgId/c/$clientId/analytics/flows'
    | '/dashboard/o/$orgId/c/$clientId/analytics/list-growth'
    | '/dashboard/o/$orgId/c/$clientId/analytics/orders'
    | '/dashboard/o/$orgId/c/$clientId/analytics/revenue'
    | '/dashboard/o/$orgId/c/$clientId/emails/create'
    | '/dashboard/o/$orgId/c/$clientId/emails/new'
    | '/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId'
    | '/dashboard/o/$orgId/c/$clientId/templates/library'
    | '/dashboard/o/$orgId/c/$clientId/templates/my'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/briefs'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/calendar'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/footer'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/header'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/intake'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/month'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/schedule'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/tasks'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/try'
    | '/dashboard/o/$orgId/settings/client/brand/integrations'
    | '/dashboard/o/$orgId/settings/client/brand/profiles'
    | '/dashboard/o/$orgId/c/$clientId/flows/$flowId'
    | '/dashboard/o/$orgId/c/$clientId/flows/create'
    | '/dashboard/o/$orgId/c/$clientId/sections/$id'
    | '/dashboard/o/$orgId/c/$clientId/analytics'
    | '/dashboard/o/$orgId/c/$clientId/calendar'
    | '/dashboard/o/$orgId/c/$clientId/flows'
    | '/dashboard/o/$orgId/c/$clientId/image-generator'
    | '/dashboard/o/$orgId/c/$clientId/inspo'
    | '/dashboard/o/$orgId/c/$clientId/media-library'
    | '/dashboard/o/$orgId/c/$clientId/sections'
    | '/dashboard/o/$orgId/c/$clientId/templates'
    | '/dashboard/o/$orgId/c/$clientId/white-glove'
    | '/dashboard/o/$orgId/settings/client/brand'
    | '/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug'
    | '/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId'
    | '/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports'
    | '/dashboard/o/$orgId/c/$clientId/emails/$templateId/chat'
    | '/dashboard/o/$orgId/c/$clientId/emails/$templateId/edit'
    | '/dashboard/o/$orgId/c/$clientId/flows/$flowId/edit'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId'
    | '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations'
    | '/dashboard/o/$orgId/settings/client/brand/$clientId/products'
  id:
    | '__root__'
    | '/'
    | '/admin-skidog'
    | '/w'
    | '/_authed'
    | '/auth'
    | '/figma-auth'
    | '/onboarding'
    | '/test-svg'
    | '/_authed/dashboard'
    | '/accept-invitation/$token'
    | '/admin-skidog/ai-costs'
    | '/admin-skidog/bg-removal'
    | '/admin-skidog/capacity'
    | '/admin-skidog/dashboard'
    | '/admin-skidog/email-documents'
    | '/admin-skidog/feature-flags'
    | '/admin-skidog/integration-tasks'
    | '/admin-skidog/organizations'
    | '/admin-skidog/plans'
    | '/admin-skidog/sam3-playground'
    | '/admin-skidog/showcase'
    | '/admin-skidog/staff'
    | '/admin-skidog/template-transfers'
    | '/admin-skidog/templates'
    | '/auth/confirm'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/p/$token'
    | '/w/capacity'
    | '/w/notifications'
    | '/w/queue'
    | '/admin-skidog/'
    | '/p/'
    | '/w/'
    | '/_authed/dashboard/notifications'
    | '/admin-skidog/email-document-sections/$id'
    | '/admin-skidog/email-document-templates/$id'
    | '/admin-skidog/white-glove/$engagementId'
    | '/client-transfers/claim/$token'
    | '/w/brand-reviews/$reviewId'
    | '/w/tickets/$ticketId'
    | '/_authed/dashboard/'
    | '/admin-skidog/$orgId/'
    | '/admin-skidog/design-inspirations/'
    | '/admin-skidog/email-archive/'
    | '/admin-skidog/white-glove/'
    | '/_authed/dashboard/o/$orgId'
    | '/_authed/dashboard/test/canvas-preview'
    | '/_authed/dashboard/test/canvaskit'
    | '/_authed/integrations/klaviyo/callback'
    | '/_authed/integrations/klaviyo/install'
    | '/admin-skidog/$orgId/clients/$clientId'
    | '/w/tickets/$ticketId/live'
    | '/_authed/integrations/klaviyo/'
    | '/_authed/dashboard/o/$orgId/clients'
    | '/_authed/dashboard/o/$orgId/settings'
    | '/_authed/dashboard/o/$orgId/c/$clientId'
    | '/_authed/dashboard/o/$orgId/settings/account'
    | '/_authed/dashboard/o/$orgId/settings/profile'
    | '/_authed/dashboard/o/$orgId/white-glove/tasks'
    | '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId'
    | '/_authed/dashboard/o/$orgId/settings/'
    | '/_authed/dashboard/o/$orgId/white-glove/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics'
    | '/_authed/dashboard/o/$orgId/c/$clientId/templates'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove'
    | '/_authed/dashboard/o/$orgId/c/$clientId/audit'
    | '/_authed/dashboard/o/$orgId/c/$clientId/content-blocks'
    | '/_authed/dashboard/o/$orgId/c/$clientId/create'
    | '/_authed/dashboard/o/$orgId/c/$clientId/email-img-upload'
    | '/_authed/dashboard/o/$orgId/settings/client/brand'
    | '/_authed/dashboard/o/$orgId/settings/client/integrations'
    | '/_authed/dashboard/o/$orgId/settings/integrations/google-drive'
    | '/_authed/dashboard/o/$orgId/settings/integrations/klaviyo'
    | '/_authed/dashboard/o/$orgId/settings/integrations/mailchimp'
    | '/_authed/dashboard/o/$orgId/settings/integrations/shopify'
    | '/_authed/dashboard/o/$orgId/settings/organization/api'
    | '/_authed/dashboard/o/$orgId/settings/organization/billing'
    | '/_authed/dashboard/o/$orgId/settings/organization/clients'
    | '/_authed/dashboard/o/$orgId/settings/organization/general'
    | '/_authed/dashboard/o/$orgId/settings/organization/team'
    | '/_authed/dashboard/o/$orgId/c/$clientId/'
    | '/_authed/dashboard/o/$orgId/settings/profile/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics/audit'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics/campaigns'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics/flows'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics/list-growth'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics/orders'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics/revenue'
    | '/_authed/dashboard/o/$orgId/c/$clientId/emails/create'
    | '/_authed/dashboard/o/$orgId/c/$clientId/emails/new'
    | '/_authed/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId'
    | '/_authed/dashboard/o/$orgId/c/$clientId/templates/library'
    | '/_authed/dashboard/o/$orgId/c/$clientId/templates/my'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/briefs'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/calendar'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/footer'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/header'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/intake'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/month'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/schedule'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tasks'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/try'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/integrations'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/profiles'
    | '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId'
    | '/_authed/dashboard_/o/$orgId/c/$clientId/flows/create'
    | '/_authed/dashboard_/o/$orgId/c/$clientId/sections/$id'
    | '/_authed/dashboard/o/$orgId/c/$clientId/analytics/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/calendar/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/flows/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/image-generator/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/inspo/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/media-library/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/sections/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/templates/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug'
    | '/_authed/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId'
    | '/_authed/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports'
    | '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/chat'
    | '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/edit'
    | '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId/edit'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/'
    | '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/'
    | '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/products/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminSkidogRouteRoute: typeof AdminSkidogRouteRouteWithChildren
  WRouteRoute: typeof WRouteRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  FigmaAuthRoute: typeof FigmaAuthRoute
  OnboardingRoute: typeof OnboardingRoute
  TestSvgRoute: typeof TestSvgRoute
  AcceptInvitationTokenRoute: typeof AcceptInvitationTokenRoute
  PTokenRoute: typeof PTokenRoute
  PIndexRoute: typeof PIndexRoute
  ClientTransfersClaimTokenRoute: typeof ClientTransfersClaimTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test-svg': {
      id: '/test-svg'
      path: '/test-svg'
      fullPath: '/test-svg'
      preLoaderRoute: typeof TestSvgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/figma-auth': {
      id: '/figma-auth'
      path: '/figma-auth'
      fullPath: '/figma-auth'
      preLoaderRoute: typeof FigmaAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w': {
      id: '/w'
      path: '/w'
      fullPath: '/w'
      preLoaderRoute: typeof WRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-skidog': {
      id: '/admin-skidog'
      path: '/admin-skidog'
      fullPath: '/admin-skidog'
      preLoaderRoute: typeof AdminSkidogRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/w/': {
      id: '/w/'
      path: '/'
      fullPath: '/w/'
      preLoaderRoute: typeof WIndexRouteImport
      parentRoute: typeof WRouteRoute
    }
    '/p/': {
      id: '/p/'
      path: '/p'
      fullPath: '/p/'
      preLoaderRoute: typeof PIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-skidog/': {
      id: '/admin-skidog/'
      path: '/'
      fullPath: '/admin-skidog/'
      preLoaderRoute: typeof AdminSkidogIndexRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/w/queue': {
      id: '/w/queue'
      path: '/queue'
      fullPath: '/w/queue'
      preLoaderRoute: typeof WQueueRouteImport
      parentRoute: typeof WRouteRoute
    }
    '/w/notifications': {
      id: '/w/notifications'
      path: '/notifications'
      fullPath: '/w/notifications'
      preLoaderRoute: typeof WNotificationsRouteImport
      parentRoute: typeof WRouteRoute
    }
    '/w/capacity': {
      id: '/w/capacity'
      path: '/capacity'
      fullPath: '/w/capacity'
      preLoaderRoute: typeof WCapacityRouteImport
      parentRoute: typeof WRouteRoute
    }
    '/p/$token': {
      id: '/p/$token'
      path: '/p/$token'
      fullPath: '/p/$token'
      preLoaderRoute: typeof PTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/confirm': {
      id: '/auth/confirm'
      path: '/confirm'
      fullPath: '/auth/confirm'
      preLoaderRoute: typeof AuthConfirmRouteImport
      parentRoute: typeof AuthRoute
    }
    '/admin-skidog/templates': {
      id: '/admin-skidog/templates'
      path: '/templates'
      fullPath: '/admin-skidog/templates'
      preLoaderRoute: typeof AdminSkidogTemplatesRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/template-transfers': {
      id: '/admin-skidog/template-transfers'
      path: '/template-transfers'
      fullPath: '/admin-skidog/template-transfers'
      preLoaderRoute: typeof AdminSkidogTemplateTransfersRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/staff': {
      id: '/admin-skidog/staff'
      path: '/staff'
      fullPath: '/admin-skidog/staff'
      preLoaderRoute: typeof AdminSkidogStaffRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/showcase': {
      id: '/admin-skidog/showcase'
      path: '/showcase'
      fullPath: '/admin-skidog/showcase'
      preLoaderRoute: typeof AdminSkidogShowcaseRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/sam3-playground': {
      id: '/admin-skidog/sam3-playground'
      path: '/sam3-playground'
      fullPath: '/admin-skidog/sam3-playground'
      preLoaderRoute: typeof AdminSkidogSam3PlaygroundRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/plans': {
      id: '/admin-skidog/plans'
      path: '/plans'
      fullPath: '/admin-skidog/plans'
      preLoaderRoute: typeof AdminSkidogPlansRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/organizations': {
      id: '/admin-skidog/organizations'
      path: '/organizations'
      fullPath: '/admin-skidog/organizations'
      preLoaderRoute: typeof AdminSkidogOrganizationsRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/integration-tasks': {
      id: '/admin-skidog/integration-tasks'
      path: '/integration-tasks'
      fullPath: '/admin-skidog/integration-tasks'
      preLoaderRoute: typeof AdminSkidogIntegrationTasksRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/feature-flags': {
      id: '/admin-skidog/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin-skidog/feature-flags'
      preLoaderRoute: typeof AdminSkidogFeatureFlagsRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/email-documents': {
      id: '/admin-skidog/email-documents'
      path: '/email-documents'
      fullPath: '/admin-skidog/email-documents'
      preLoaderRoute: typeof AdminSkidogEmailDocumentsRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/dashboard': {
      id: '/admin-skidog/dashboard'
      path: '/dashboard'
      fullPath: '/admin-skidog/dashboard'
      preLoaderRoute: typeof AdminSkidogDashboardRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/capacity': {
      id: '/admin-skidog/capacity'
      path: '/capacity'
      fullPath: '/admin-skidog/capacity'
      preLoaderRoute: typeof AdminSkidogCapacityRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/bg-removal': {
      id: '/admin-skidog/bg-removal'
      path: '/bg-removal'
      fullPath: '/admin-skidog/bg-removal'
      preLoaderRoute: typeof AdminSkidogBgRemovalRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/ai-costs': {
      id: '/admin-skidog/ai-costs'
      path: '/ai-costs'
      fullPath: '/admin-skidog/ai-costs'
      preLoaderRoute: typeof AdminSkidogAiCostsRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/accept-invitation/$token': {
      id: '/accept-invitation/$token'
      path: '/accept-invitation/$token'
      fullPath: '/accept-invitation/$token'
      preLoaderRoute: typeof AcceptInvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/admin-skidog/white-glove/': {
      id: '/admin-skidog/white-glove/'
      path: '/white-glove'
      fullPath: '/admin-skidog/white-glove/'
      preLoaderRoute: typeof AdminSkidogWhiteGloveIndexRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/email-archive/': {
      id: '/admin-skidog/email-archive/'
      path: '/email-archive'
      fullPath: '/admin-skidog/email-archive/'
      preLoaderRoute: typeof AdminSkidogEmailArchiveIndexRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/design-inspirations/': {
      id: '/admin-skidog/design-inspirations/'
      path: '/design-inspirations'
      fullPath: '/admin-skidog/design-inspirations/'
      preLoaderRoute: typeof AdminSkidogDesignInspirationsIndexRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/$orgId/': {
      id: '/admin-skidog/$orgId/'
      path: '/$orgId'
      fullPath: '/admin-skidog/$orgId/'
      preLoaderRoute: typeof AdminSkidogOrgIdIndexRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/_authed/dashboard/': {
      id: '/_authed/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthedDashboardIndexRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/w/tickets/$ticketId': {
      id: '/w/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/w/tickets/$ticketId'
      preLoaderRoute: typeof WTicketsTicketIdRouteImport
      parentRoute: typeof WRouteRoute
    }
    '/w/brand-reviews/$reviewId': {
      id: '/w/brand-reviews/$reviewId'
      path: '/brand-reviews/$reviewId'
      fullPath: '/w/brand-reviews/$reviewId'
      preLoaderRoute: typeof WBrandReviewsReviewIdRouteImport
      parentRoute: typeof WRouteRoute
    }
    '/client-transfers/claim/$token': {
      id: '/client-transfers/claim/$token'
      path: '/client-transfers/claim/$token'
      fullPath: '/client-transfers/claim/$token'
      preLoaderRoute: typeof ClientTransfersClaimTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-skidog/white-glove/$engagementId': {
      id: '/admin-skidog/white-glove/$engagementId'
      path: '/white-glove/$engagementId'
      fullPath: '/admin-skidog/white-glove/$engagementId'
      preLoaderRoute: typeof AdminSkidogWhiteGloveEngagementIdRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/email-document-templates/$id': {
      id: '/admin-skidog/email-document-templates/$id'
      path: '/email-document-templates/$id'
      fullPath: '/admin-skidog/email-document-templates/$id'
      preLoaderRoute: typeof AdminSkidogEmailDocumentTemplatesIdRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/admin-skidog/email-document-sections/$id': {
      id: '/admin-skidog/email-document-sections/$id'
      path: '/email-document-sections/$id'
      fullPath: '/admin-skidog/email-document-sections/$id'
      preLoaderRoute: typeof AdminSkidogEmailDocumentSectionsIdRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/_authed/dashboard/notifications': {
      id: '/_authed/dashboard/notifications'
      path: '/notifications'
      fullPath: '/dashboard/notifications'
      preLoaderRoute: typeof AuthedDashboardNotificationsRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/integrations/klaviyo/': {
      id: '/_authed/integrations/klaviyo/'
      path: '/integrations/klaviyo'
      fullPath: '/integrations/klaviyo/'
      preLoaderRoute: typeof AuthedIntegrationsKlaviyoIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/w/tickets/$ticketId/live': {
      id: '/w/tickets/$ticketId/live'
      path: '/live'
      fullPath: '/w/tickets/$ticketId/live'
      preLoaderRoute: typeof WTicketsTicketIdLiveRouteImport
      parentRoute: typeof WTicketsTicketIdRoute
    }
    '/admin-skidog/$orgId/clients/$clientId': {
      id: '/admin-skidog/$orgId/clients/$clientId'
      path: '/$orgId/clients/$clientId'
      fullPath: '/admin-skidog/$orgId/clients/$clientId'
      preLoaderRoute: typeof AdminSkidogOrgIdClientsClientIdRouteImport
      parentRoute: typeof AdminSkidogRouteRoute
    }
    '/_authed/integrations/klaviyo/install': {
      id: '/_authed/integrations/klaviyo/install'
      path: '/integrations/klaviyo/install'
      fullPath: '/integrations/klaviyo/install'
      preLoaderRoute: typeof AuthedIntegrationsKlaviyoInstallRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/integrations/klaviyo/callback': {
      id: '/_authed/integrations/klaviyo/callback'
      path: '/integrations/klaviyo/callback'
      fullPath: '/integrations/klaviyo/callback'
      preLoaderRoute: typeof AuthedIntegrationsKlaviyoCallbackRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard/test/canvaskit': {
      id: '/_authed/dashboard/test/canvaskit'
      path: '/test/canvaskit'
      fullPath: '/dashboard/test/canvaskit'
      preLoaderRoute: typeof AuthedDashboardTestCanvaskitRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/test/canvas-preview': {
      id: '/_authed/dashboard/test/canvas-preview'
      path: '/test/canvas-preview'
      fullPath: '/dashboard/test/canvas-preview'
      preLoaderRoute: typeof AuthedDashboardTestCanvasPreviewRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/o/$orgId': {
      id: '/_authed/dashboard/o/$orgId'
      path: '/o/$orgId'
      fullPath: '/dashboard/o/$orgId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdRouteRouteImport
      parentRoute: typeof AuthedDashboardRoute
    }
    '/_authed/dashboard/o/$orgId/settings': {
      id: '/_authed/dashboard/o/$orgId/settings'
      path: '/settings'
      fullPath: '/dashboard/o/$orgId/settings'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/clients': {
      id: '/_authed/dashboard/o/$orgId/clients'
      path: '/clients'
      fullPath: '/dashboard/o/$orgId/clients'
      preLoaderRoute: typeof AuthedDashboardOOrgIdClientsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/white-glove/': {
      id: '/_authed/dashboard/o/$orgId/white-glove/'
      path: '/white-glove'
      fullPath: '/dashboard/o/$orgId/white-glove/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdWhiteGloveIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/settings/': {
      id: '/_authed/dashboard/o/$orgId/settings/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/settings/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId': {
      id: '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/admin-skidog/$orgId/clients/$clientId/integrations/$integrationId'
      preLoaderRoute: typeof AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRouteImport
      parentRoute: typeof AdminSkidogOrgIdClientsClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/white-glove/tasks': {
      id: '/_authed/dashboard/o/$orgId/white-glove/tasks'
      path: '/white-glove/tasks'
      fullPath: '/dashboard/o/$orgId/white-glove/tasks'
      preLoaderRoute: typeof AuthedDashboardOOrgIdWhiteGloveTasksRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/settings/profile': {
      id: '/_authed/dashboard/o/$orgId/settings/profile'
      path: '/profile'
      fullPath: '/dashboard/o/$orgId/settings/profile'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsProfileRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/account': {
      id: '/_authed/dashboard/o/$orgId/settings/account'
      path: '/account'
      fullPath: '/dashboard/o/$orgId/settings/account'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsAccountRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId'
      path: '/c/$clientId'
      fullPath: '/dashboard/o/$orgId/c/$clientId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/settings/profile/': {
      id: '/_authed/dashboard/o/$orgId/settings/profile/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/settings/profile/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsProfileIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsProfileRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/c/$clientId/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/settings/organization/team': {
      id: '/_authed/dashboard/o/$orgId/settings/organization/team'
      path: '/organization/team'
      fullPath: '/dashboard/o/$orgId/settings/organization/team'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationTeamRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/organization/general': {
      id: '/_authed/dashboard/o/$orgId/settings/organization/general'
      path: '/organization/general'
      fullPath: '/dashboard/o/$orgId/settings/organization/general'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationGeneralRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/organization/clients': {
      id: '/_authed/dashboard/o/$orgId/settings/organization/clients'
      path: '/organization/clients'
      fullPath: '/dashboard/o/$orgId/settings/organization/clients'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationClientsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/organization/billing': {
      id: '/_authed/dashboard/o/$orgId/settings/organization/billing'
      path: '/organization/billing'
      fullPath: '/dashboard/o/$orgId/settings/organization/billing'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationBillingRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/organization/api': {
      id: '/_authed/dashboard/o/$orgId/settings/organization/api'
      path: '/organization/api'
      fullPath: '/dashboard/o/$orgId/settings/organization/api'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationApiRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/integrations/shopify': {
      id: '/_authed/dashboard/o/$orgId/settings/integrations/shopify'
      path: '/integrations/shopify'
      fullPath: '/dashboard/o/$orgId/settings/integrations/shopify'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsShopifyRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/integrations/mailchimp': {
      id: '/_authed/dashboard/o/$orgId/settings/integrations/mailchimp'
      path: '/integrations/mailchimp'
      fullPath: '/dashboard/o/$orgId/settings/integrations/mailchimp'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/integrations/klaviyo': {
      id: '/_authed/dashboard/o/$orgId/settings/integrations/klaviyo'
      path: '/integrations/klaviyo'
      fullPath: '/dashboard/o/$orgId/settings/integrations/klaviyo'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/integrations/google-drive': {
      id: '/_authed/dashboard/o/$orgId/settings/integrations/google-drive'
      path: '/integrations/google-drive'
      fullPath: '/dashboard/o/$orgId/settings/integrations/google-drive'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/integrations': {
      id: '/_authed/dashboard/o/$orgId/settings/client/integrations'
      path: '/client/integrations'
      fullPath: '/dashboard/o/$orgId/settings/client/integrations'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientIntegrationsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand'
      path: '/client/brand'
      fullPath: '/dashboard/o/$orgId/settings/client/brand'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/email-img-upload': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/email-img-upload'
      path: '/email-img-upload'
      fullPath: '/dashboard/o/$orgId/c/$clientId/email-img-upload'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdEmailImgUploadRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/create': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/create'
      path: '/create'
      fullPath: '/dashboard/o/$orgId/c/$clientId/create'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdCreateRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/content-blocks': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/content-blocks'
      path: '/content-blocks'
      fullPath: '/dashboard/o/$orgId/c/$clientId/content-blocks'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdContentBlocksRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/audit': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/audit'
      path: '/audit'
      fullPath: '/dashboard/o/$orgId/c/$clientId/audit'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAuditRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove'
      path: '/white-glove'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/templates': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/templates'
      path: '/templates'
      fullPath: '/dashboard/o/$orgId/c/$clientId/templates'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics'
      path: '/analytics'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/templates/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/templates/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/c/$clientId/templates/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/sections/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/sections/'
      path: '/sections'
      fullPath: '/dashboard/o/$orgId/c/$clientId/sections/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdSectionsIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/media-library/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/media-library/'
      path: '/media-library'
      fullPath: '/dashboard/o/$orgId/c/$clientId/media-library/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/inspo/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/inspo/'
      path: '/inspo'
      fullPath: '/dashboard/o/$orgId/c/$clientId/inspo/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdInspoIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/image-generator/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/image-generator/'
      path: '/image-generator'
      fullPath: '/dashboard/o/$orgId/c/$clientId/image-generator/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/flows/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/flows/'
      path: '/flows'
      fullPath: '/dashboard/o/$orgId/c/$clientId/flows/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/calendar/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/calendar/'
      path: '/calendar'
      fullPath: '/dashboard/o/$orgId/c/$clientId/calendar/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdCalendarIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics/': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute
    }
    '/_authed/dashboard_/o/$orgId/c/$clientId/sections/$id': {
      id: '/_authed/dashboard_/o/$orgId/c/$clientId/sections/$id'
      path: '/dashboard/o/$orgId/c/$clientId/sections/$id'
      fullPath: '/dashboard/o/$orgId/c/$clientId/sections/$id'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdSectionsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard_/o/$orgId/c/$clientId/flows/create': {
      id: '/_authed/dashboard_/o/$orgId/c/$clientId/flows/create'
      path: '/dashboard/o/$orgId/c/$clientId/flows/create'
      fullPath: '/dashboard/o/$orgId/c/$clientId/flows/create'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsCreateRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId': {
      id: '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId'
      path: '/dashboard/o/$orgId/c/$clientId/flows/$flowId'
      fullPath: '/dashboard/o/$orgId/c/$clientId/flows/$flowId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/profiles': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/profiles'
      path: '/profiles'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/profiles'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandProfilesRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/integrations': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/integrations'
      path: '/integrations'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/integrations'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId'
      path: '/$clientId'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/try': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/try'
      path: '/try'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/try'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTryRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tasks': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tasks'
      path: '/tasks'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/tasks'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/schedule': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/schedule'
      path: '/schedule'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/schedule'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/month': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/month'
      path: '/month'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/month'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/intake': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/intake'
      path: '/intake'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/intake'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/header': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/header'
      path: '/header'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/header'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/footer': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/footer'
      path: '/footer'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/footer'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/calendar': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/calendar'
      path: '/calendar'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/calendar'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/briefs': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/briefs'
      path: '/briefs'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/briefs'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/templates/my': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/templates/my'
      path: '/my'
      fullPath: '/dashboard/o/$orgId/c/$clientId/templates/my'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesMyRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/templates/library': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/templates/library'
      path: '/library'
      fullPath: '/dashboard/o/$orgId/c/$clientId/templates/library'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesLibraryRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId'
      path: '/sms/$smsMessageId'
      fullPath: '/dashboard/o/$orgId/c/$clientId/sms/$smsMessageId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/emails/new': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/emails/new'
      path: '/emails/new'
      fullPath: '/dashboard/o/$orgId/c/$clientId/emails/new'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsNewRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/emails/create': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/emails/create'
      path: '/emails/create'
      fullPath: '/dashboard/o/$orgId/c/$clientId/emails/create'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsCreateRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics/revenue': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics/revenue'
      path: '/revenue'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics/revenue'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics/orders': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics/orders'
      path: '/orders'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics/orders'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics/list-growth': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics/list-growth'
      path: '/list-growth'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics/list-growth'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics/flows': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics/flows'
      path: '/flows'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics/flows'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics/campaigns': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics/campaigns'
      path: '/campaigns'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics/campaigns'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/analytics/audit': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/analytics/audit'
      path: '/audit'
      fullPath: '/dashboard/o/$orgId/c/$clientId/analytics/audit'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsAuditRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/'
      path: '/'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId/edit': {
      id: '/_authed/dashboard_/o/$orgId/c/$clientId/flows/$flowId/edit'
      path: '/edit'
      fullPath: '/dashboard/o/$orgId/c/$clientId/flows/$flowId/edit'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdRoute
    }
    '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/edit': {
      id: '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/edit'
      path: '/dashboard/o/$orgId/c/$clientId/emails/$templateId/edit'
      fullPath: '/dashboard/o/$orgId/c/$clientId/emails/$templateId/edit'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/chat': {
      id: '/_authed/dashboard_/o/$orgId/c/$clientId/emails/$templateId/chat'
      path: '/dashboard/o/$orgId/c/$clientId/emails/$templateId/chat'
      fullPath: '/dashboard/o/$orgId/c/$clientId/emails/$templateId/chat'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports'
      path: '/page-imports'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/page-imports'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge'
      path: '/knowledge'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/knowledge'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId'
      path: '/review/$ticketId'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/review/$ticketId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId'
      path: '/media-library/canvas/$canvasId'
      fullPath: '/dashboard/o/$orgId/c/$clientId/media-library/canvas/$canvasId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId'
      path: '/inspo/lists/$listId'
      fullPath: '/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdInspoListsListIdRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug'
      path: '/inspo/brands/$slug'
      fullPath: '/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/products/': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/products/'
      path: '/products'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/products/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/'
      path: '/integrations'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce'
      path: '/integrations/woocommerce'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/woocommerce'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify'
      path: '/integrations/shopify'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/shopify'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend'
      path: '/integrations/omnisend'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/omnisend'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp'
      path: '/integrations/mailchimp'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/mailchimp'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo'
      path: '/integrations/klaviyo'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/klaviyo'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot'
      path: '/integrations/hubspot'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/hubspot'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive'
      path: '/integrations/google-drive'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/google-drive'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma'
      path: '/integrations/figma'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/figma'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox'
      path: '/integrations/dropbox'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/dropbox'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact'
      path: '/integrations/constant-contact'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/constant-contact'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner'
      path: '/integrations/campaigner'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaigner'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor'
      path: '/integrations/campaign-monitor'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/campaign-monitor'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo': {
      id: '/_authed/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo'
      path: '/integrations/brevo'
      fullPath: '/dashboard/o/$orgId/settings/client/brand/$clientId/integrations/brevo'
      preLoaderRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute
    }
    '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review': {
      id: '/_authed/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review'
      path: '/review'
      fullPath: '/dashboard/o/$orgId/c/$clientId/white-glove/tickets/$ticketId/review'
      preLoaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRouteImport
      parentRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRoute
    }
  }
}

interface AdminSkidogOrgIdClientsClientIdRouteChildren {
  AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute: typeof AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute
}

const AdminSkidogOrgIdClientsClientIdRouteChildren: AdminSkidogOrgIdClientsClientIdRouteChildren =
  {
    AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute:
      AdminSkidogOrgIdClientsClientIdIntegrationsIntegrationIdRoute,
  }

const AdminSkidogOrgIdClientsClientIdRouteWithChildren =
  AdminSkidogOrgIdClientsClientIdRoute._addFileChildren(
    AdminSkidogOrgIdClientsClientIdRouteChildren,
  )

interface AdminSkidogRouteRouteChildren {
  AdminSkidogAiCostsRoute: typeof AdminSkidogAiCostsRoute
  AdminSkidogBgRemovalRoute: typeof AdminSkidogBgRemovalRoute
  AdminSkidogCapacityRoute: typeof AdminSkidogCapacityRoute
  AdminSkidogDashboardRoute: typeof AdminSkidogDashboardRoute
  AdminSkidogEmailDocumentsRoute: typeof AdminSkidogEmailDocumentsRoute
  AdminSkidogFeatureFlagsRoute: typeof AdminSkidogFeatureFlagsRoute
  AdminSkidogIntegrationTasksRoute: typeof AdminSkidogIntegrationTasksRoute
  AdminSkidogOrganizationsRoute: typeof AdminSkidogOrganizationsRoute
  AdminSkidogPlansRoute: typeof AdminSkidogPlansRoute
  AdminSkidogSam3PlaygroundRoute: typeof AdminSkidogSam3PlaygroundRoute
  AdminSkidogShowcaseRoute: typeof AdminSkidogShowcaseRoute
  AdminSkidogStaffRoute: typeof AdminSkidogStaffRoute
  AdminSkidogTemplateTransfersRoute: typeof AdminSkidogTemplateTransfersRoute
  AdminSkidogTemplatesRoute: typeof AdminSkidogTemplatesRoute
  AdminSkidogIndexRoute: typeof AdminSkidogIndexRoute
  AdminSkidogEmailDocumentSectionsIdRoute: typeof AdminSkidogEmailDocumentSectionsIdRoute
  AdminSkidogEmailDocumentTemplatesIdRoute: typeof AdminSkidogEmailDocumentTemplatesIdRoute
  AdminSkidogWhiteGloveEngagementIdRoute: typeof AdminSkidogWhiteGloveEngagementIdRoute
  AdminSkidogOrgIdIndexRoute: typeof AdminSkidogOrgIdIndexRoute
  AdminSkidogDesignInspirationsIndexRoute: typeof AdminSkidogDesignInspirationsIndexRoute
  AdminSkidogEmailArchiveIndexRoute: typeof AdminSkidogEmailArchiveIndexRoute
  AdminSkidogWhiteGloveIndexRoute: typeof AdminSkidogWhiteGloveIndexRoute
  AdminSkidogOrgIdClientsClientIdRoute: typeof AdminSkidogOrgIdClientsClientIdRouteWithChildren
}

const AdminSkidogRouteRouteChildren: AdminSkidogRouteRouteChildren = {
  AdminSkidogAiCostsRoute: AdminSkidogAiCostsRoute,
  AdminSkidogBgRemovalRoute: AdminSkidogBgRemovalRoute,
  AdminSkidogCapacityRoute: AdminSkidogCapacityRoute,
  AdminSkidogDashboardRoute: AdminSkidogDashboardRoute,
  AdminSkidogEmailDocumentsRoute: AdminSkidogEmailDocumentsRoute,
  AdminSkidogFeatureFlagsRoute: AdminSkidogFeatureFlagsRoute,
  AdminSkidogIntegrationTasksRoute: AdminSkidogIntegrationTasksRoute,
  AdminSkidogOrganizationsRoute: AdminSkidogOrganizationsRoute,
  AdminSkidogPlansRoute: AdminSkidogPlansRoute,
  AdminSkidogSam3PlaygroundRoute: AdminSkidogSam3PlaygroundRoute,
  AdminSkidogShowcaseRoute: AdminSkidogShowcaseRoute,
  AdminSkidogStaffRoute: AdminSkidogStaffRoute,
  AdminSkidogTemplateTransfersRoute: AdminSkidogTemplateTransfersRoute,
  AdminSkidogTemplatesRoute: AdminSkidogTemplatesRoute,
  AdminSkidogIndexRoute: AdminSkidogIndexRoute,
  AdminSkidogEmailDocumentSectionsIdRoute:
    AdminSkidogEmailDocumentSectionsIdRoute,
  AdminSkidogEmailDocumentTemplatesIdRoute:
    AdminSkidogEmailDocumentTemplatesIdRoute,
  AdminSkidogWhiteGloveEngagementIdRoute:
    AdminSkidogWhiteGloveEngagementIdRoute,
  AdminSkidogOrgIdIndexRoute: AdminSkidogOrgIdIndexRoute,
  AdminSkidogDesignInspirationsIndexRoute:
    AdminSkidogDesignInspirationsIndexRoute,
  AdminSkidogEmailArchiveIndexRoute: AdminSkidogEmailArchiveIndexRoute,
  AdminSkidogWhiteGloveIndexRoute: AdminSkidogWhiteGloveIndexRoute,
  AdminSkidogOrgIdClientsClientIdRoute:
    AdminSkidogOrgIdClientsClientIdRouteWithChildren,
}

const AdminSkidogRouteRouteWithChildren =
  AdminSkidogRouteRoute._addFileChildren(AdminSkidogRouteRouteChildren)

interface WTicketsTicketIdRouteChildren {
  WTicketsTicketIdLiveRoute: typeof WTicketsTicketIdLiveRoute
}

const WTicketsTicketIdRouteChildren: WTicketsTicketIdRouteChildren = {
  WTicketsTicketIdLiveRoute: WTicketsTicketIdLiveRoute,
}

const WTicketsTicketIdRouteWithChildren =
  WTicketsTicketIdRoute._addFileChildren(WTicketsTicketIdRouteChildren)

interface WRouteRouteChildren {
  WCapacityRoute: typeof WCapacityRoute
  WNotificationsRoute: typeof WNotificationsRoute
  WQueueRoute: typeof WQueueRoute
  WIndexRoute: typeof WIndexRoute
  WBrandReviewsReviewIdRoute: typeof WBrandReviewsReviewIdRoute
  WTicketsTicketIdRoute: typeof WTicketsTicketIdRouteWithChildren
}

const WRouteRouteChildren: WRouteRouteChildren = {
  WCapacityRoute: WCapacityRoute,
  WNotificationsRoute: WNotificationsRoute,
  WQueueRoute: WQueueRoute,
  WIndexRoute: WIndexRoute,
  WBrandReviewsReviewIdRoute: WBrandReviewsReviewIdRoute,
  WTicketsTicketIdRoute: WTicketsTicketIdRouteWithChildren,
}

const WRouteRouteWithChildren =
  WRouteRoute._addFileChildren(WRouteRouteChildren)

interface AuthedDashboardOOrgIdSettingsProfileRouteChildren {
  AuthedDashboardOOrgIdSettingsProfileIndexRoute: typeof AuthedDashboardOOrgIdSettingsProfileIndexRoute
}

const AuthedDashboardOOrgIdSettingsProfileRouteChildren: AuthedDashboardOOrgIdSettingsProfileRouteChildren =
  {
    AuthedDashboardOOrgIdSettingsProfileIndexRoute:
      AuthedDashboardOOrgIdSettingsProfileIndexRoute,
  }

const AuthedDashboardOOrgIdSettingsProfileRouteWithChildren =
  AuthedDashboardOOrgIdSettingsProfileRoute._addFileChildren(
    AuthedDashboardOOrgIdSettingsProfileRouteChildren,
  )

interface AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteChildren {
  AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute
  AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute
}

const AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteChildren: AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteChildren =
  {
    AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdKnowledgeRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdPageImportsRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIndexRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsBrevoRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignMonitorRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsCampaignerRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsConstantContactRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsDropboxRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsFigmaRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsGoogleDriveRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsHubspotRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsKlaviyoRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsMailchimpRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsOmnisendRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsShopifyRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsWoocommerceRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdIntegrationsIndexRoute,
    AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdProductsIndexRoute,
  }

const AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteWithChildren =
  AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute._addFileChildren(
    AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteChildren,
  )

interface AuthedDashboardOOrgIdSettingsClientBrandRouteChildren {
  AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteWithChildren
  AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute
  AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute
  AuthedDashboardOOrgIdSettingsClientBrandIndexRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandIndexRoute
}

const AuthedDashboardOOrgIdSettingsClientBrandRouteChildren: AuthedDashboardOOrgIdSettingsClientBrandRouteChildren =
  {
    AuthedDashboardOOrgIdSettingsClientBrandClientIdRoute:
      AuthedDashboardOOrgIdSettingsClientBrandClientIdRouteWithChildren,
    AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute:
      AuthedDashboardOOrgIdSettingsClientBrandIntegrationsRoute,
    AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute:
      AuthedDashboardOOrgIdSettingsClientBrandProfilesRoute,
    AuthedDashboardOOrgIdSettingsClientBrandIndexRoute:
      AuthedDashboardOOrgIdSettingsClientBrandIndexRoute,
  }

const AuthedDashboardOOrgIdSettingsClientBrandRouteWithChildren =
  AuthedDashboardOOrgIdSettingsClientBrandRoute._addFileChildren(
    AuthedDashboardOOrgIdSettingsClientBrandRouteChildren,
  )

interface AuthedDashboardOOrgIdSettingsRouteChildren {
  AuthedDashboardOOrgIdSettingsAccountRoute: typeof AuthedDashboardOOrgIdSettingsAccountRoute
  AuthedDashboardOOrgIdSettingsProfileRoute: typeof AuthedDashboardOOrgIdSettingsProfileRouteWithChildren
  AuthedDashboardOOrgIdSettingsIndexRoute: typeof AuthedDashboardOOrgIdSettingsIndexRoute
  AuthedDashboardOOrgIdSettingsClientBrandRoute: typeof AuthedDashboardOOrgIdSettingsClientBrandRouteWithChildren
  AuthedDashboardOOrgIdSettingsClientIntegrationsRoute: typeof AuthedDashboardOOrgIdSettingsClientIntegrationsRoute
  AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute
  AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute
  AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute
  AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute: typeof AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute
  AuthedDashboardOOrgIdSettingsOrganizationApiRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationApiRoute
  AuthedDashboardOOrgIdSettingsOrganizationBillingRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationBillingRoute
  AuthedDashboardOOrgIdSettingsOrganizationClientsRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationClientsRoute
  AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute
  AuthedDashboardOOrgIdSettingsOrganizationTeamRoute: typeof AuthedDashboardOOrgIdSettingsOrganizationTeamRoute
}

const AuthedDashboardOOrgIdSettingsRouteChildren: AuthedDashboardOOrgIdSettingsRouteChildren =
  {
    AuthedDashboardOOrgIdSettingsAccountRoute:
      AuthedDashboardOOrgIdSettingsAccountRoute,
    AuthedDashboardOOrgIdSettingsProfileRoute:
      AuthedDashboardOOrgIdSettingsProfileRouteWithChildren,
    AuthedDashboardOOrgIdSettingsIndexRoute:
      AuthedDashboardOOrgIdSettingsIndexRoute,
    AuthedDashboardOOrgIdSettingsClientBrandRoute:
      AuthedDashboardOOrgIdSettingsClientBrandRouteWithChildren,
    AuthedDashboardOOrgIdSettingsClientIntegrationsRoute:
      AuthedDashboardOOrgIdSettingsClientIntegrationsRoute,
    AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute:
      AuthedDashboardOOrgIdSettingsIntegrationsGoogleDriveRoute,
    AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute:
      AuthedDashboardOOrgIdSettingsIntegrationsKlaviyoRoute,
    AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute:
      AuthedDashboardOOrgIdSettingsIntegrationsMailchimpRoute,
    AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute:
      AuthedDashboardOOrgIdSettingsIntegrationsShopifyRoute,
    AuthedDashboardOOrgIdSettingsOrganizationApiRoute:
      AuthedDashboardOOrgIdSettingsOrganizationApiRoute,
    AuthedDashboardOOrgIdSettingsOrganizationBillingRoute:
      AuthedDashboardOOrgIdSettingsOrganizationBillingRoute,
    AuthedDashboardOOrgIdSettingsOrganizationClientsRoute:
      AuthedDashboardOOrgIdSettingsOrganizationClientsRoute,
    AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute:
      AuthedDashboardOOrgIdSettingsOrganizationGeneralRoute,
    AuthedDashboardOOrgIdSettingsOrganizationTeamRoute:
      AuthedDashboardOOrgIdSettingsOrganizationTeamRoute,
  }

const AuthedDashboardOOrgIdSettingsRouteWithChildren =
  AuthedDashboardOOrgIdSettingsRoute._addFileChildren(
    AuthedDashboardOOrgIdSettingsRouteChildren,
  )

interface AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteChildren {
  AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute
  AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute
  AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute
  AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute
  AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute
  AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute
  AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute
}

const AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteChildren: AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteChildren =
  {
    AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsAuditRoute,
    AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsCampaignsRoute,
    AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsFlowsRoute,
    AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsListGrowthRoute,
    AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsOrdersRoute,
    AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsRevenueRoute,
    AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsIndexRoute,
  }

const AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteWithChildren =
  AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute._addFileChildren(
    AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteChildren,
  )

interface AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteChildren {
  AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute
  AuthedDashboardOOrgIdCClientIdTemplatesMyRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesMyRoute
  AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute
}

const AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteChildren: AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteChildren =
  {
    AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute:
      AuthedDashboardOOrgIdCClientIdTemplatesLibraryRoute,
    AuthedDashboardOOrgIdCClientIdTemplatesMyRoute:
      AuthedDashboardOOrgIdCClientIdTemplatesMyRoute,
    AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute:
      AuthedDashboardOOrgIdCClientIdTemplatesIndexRoute,
  }

const AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteWithChildren =
  AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute._addFileChildren(
    AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteChildren,
  )

interface AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteChildren {
  AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute
}

const AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteChildren: AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteChildren =
  {
    AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdReviewRoute,
  }

const AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteWithChildren =
  AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRoute._addFileChildren(
    AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteChildren,
  )

interface AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteChildren {
  AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute
  AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteWithChildren
}

const AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteChildren: AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteChildren =
  {
    AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveBriefsRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveCalendarRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveFooterRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveHeaderRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveIntakeRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveMonthRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveScheduleRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveTasksRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveTryRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveIndexRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveReviewTicketIdRoute,
    AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveTicketsTicketIdRouteWithChildren,
  }

const AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteWithChildren =
  AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute._addFileChildren(
    AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteChildren,
  )

interface AuthedDashboardOOrgIdCClientIdRouteRouteChildren {
  AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute: typeof AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteWithChildren
  AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute: typeof AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteWithChildren
  AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute: typeof AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteWithChildren
  AuthedDashboardOOrgIdCClientIdAuditRoute: typeof AuthedDashboardOOrgIdCClientIdAuditRoute
  AuthedDashboardOOrgIdCClientIdContentBlocksRoute: typeof AuthedDashboardOOrgIdCClientIdContentBlocksRoute
  AuthedDashboardOOrgIdCClientIdCreateRoute: typeof AuthedDashboardOOrgIdCClientIdCreateRoute
  AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute: typeof AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute
  AuthedDashboardOOrgIdCClientIdIndexRoute: typeof AuthedDashboardOOrgIdCClientIdIndexRoute
  AuthedDashboardOOrgIdCClientIdEmailsCreateRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsCreateRoute
  AuthedDashboardOOrgIdCClientIdEmailsNewRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsNewRoute
  AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute: typeof AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute
  AuthedDashboardOOrgIdCClientIdCalendarIndexRoute: typeof AuthedDashboardOOrgIdCClientIdCalendarIndexRoute
  AuthedDashboardOOrgIdCClientIdFlowsIndexRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsIndexRoute
  AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute: typeof AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute
  AuthedDashboardOOrgIdCClientIdInspoIndexRoute: typeof AuthedDashboardOOrgIdCClientIdInspoIndexRoute
  AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute: typeof AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute
  AuthedDashboardOOrgIdCClientIdSectionsIndexRoute: typeof AuthedDashboardOOrgIdCClientIdSectionsIndexRoute
  AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute: typeof AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute
  AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute: typeof AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute
  AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute: typeof AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute
}

const AuthedDashboardOOrgIdCClientIdRouteRouteChildren: AuthedDashboardOOrgIdCClientIdRouteRouteChildren =
  {
    AuthedDashboardOOrgIdCClientIdAnalyticsRouteRoute:
      AuthedDashboardOOrgIdCClientIdAnalyticsRouteRouteWithChildren,
    AuthedDashboardOOrgIdCClientIdTemplatesRouteRoute:
      AuthedDashboardOOrgIdCClientIdTemplatesRouteRouteWithChildren,
    AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRoute:
      AuthedDashboardOOrgIdCClientIdWhiteGloveRouteRouteWithChildren,
    AuthedDashboardOOrgIdCClientIdAuditRoute:
      AuthedDashboardOOrgIdCClientIdAuditRoute,
    AuthedDashboardOOrgIdCClientIdContentBlocksRoute:
      AuthedDashboardOOrgIdCClientIdContentBlocksRoute,
    AuthedDashboardOOrgIdCClientIdCreateRoute:
      AuthedDashboardOOrgIdCClientIdCreateRoute,
    AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute:
      AuthedDashboardOOrgIdCClientIdEmailImgUploadRoute,
    AuthedDashboardOOrgIdCClientIdIndexRoute:
      AuthedDashboardOOrgIdCClientIdIndexRoute,
    AuthedDashboardOOrgIdCClientIdEmailsCreateRoute:
      AuthedDashboardOOrgIdCClientIdEmailsCreateRoute,
    AuthedDashboardOOrgIdCClientIdEmailsNewRoute:
      AuthedDashboardOOrgIdCClientIdEmailsNewRoute,
    AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute:
      AuthedDashboardOOrgIdCClientIdSmsSmsMessageIdRoute,
    AuthedDashboardOOrgIdCClientIdCalendarIndexRoute:
      AuthedDashboardOOrgIdCClientIdCalendarIndexRoute,
    AuthedDashboardOOrgIdCClientIdFlowsIndexRoute:
      AuthedDashboardOOrgIdCClientIdFlowsIndexRoute,
    AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute:
      AuthedDashboardOOrgIdCClientIdImageGeneratorIndexRoute,
    AuthedDashboardOOrgIdCClientIdInspoIndexRoute:
      AuthedDashboardOOrgIdCClientIdInspoIndexRoute,
    AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute:
      AuthedDashboardOOrgIdCClientIdMediaLibraryIndexRoute,
    AuthedDashboardOOrgIdCClientIdSectionsIndexRoute:
      AuthedDashboardOOrgIdCClientIdSectionsIndexRoute,
    AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute:
      AuthedDashboardOOrgIdCClientIdInspoBrandsSlugRoute,
    AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute:
      AuthedDashboardOOrgIdCClientIdInspoListsListIdRoute,
    AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute:
      AuthedDashboardOOrgIdCClientIdMediaLibraryCanvasCanvasIdRoute,
  }

const AuthedDashboardOOrgIdCClientIdRouteRouteWithChildren =
  AuthedDashboardOOrgIdCClientIdRouteRoute._addFileChildren(
    AuthedDashboardOOrgIdCClientIdRouteRouteChildren,
  )

interface AuthedDashboardOOrgIdRouteRouteChildren {
  AuthedDashboardOOrgIdClientsRoute: typeof AuthedDashboardOOrgIdClientsRoute
  AuthedDashboardOOrgIdSettingsRoute: typeof AuthedDashboardOOrgIdSettingsRouteWithChildren
  AuthedDashboardOOrgIdCClientIdRouteRoute: typeof AuthedDashboardOOrgIdCClientIdRouteRouteWithChildren
  AuthedDashboardOOrgIdWhiteGloveTasksRoute: typeof AuthedDashboardOOrgIdWhiteGloveTasksRoute
  AuthedDashboardOOrgIdWhiteGloveIndexRoute: typeof AuthedDashboardOOrgIdWhiteGloveIndexRoute
}

const AuthedDashboardOOrgIdRouteRouteChildren: AuthedDashboardOOrgIdRouteRouteChildren =
  {
    AuthedDashboardOOrgIdClientsRoute: AuthedDashboardOOrgIdClientsRoute,
    AuthedDashboardOOrgIdSettingsRoute:
      AuthedDashboardOOrgIdSettingsRouteWithChildren,
    AuthedDashboardOOrgIdCClientIdRouteRoute:
      AuthedDashboardOOrgIdCClientIdRouteRouteWithChildren,
    AuthedDashboardOOrgIdWhiteGloveTasksRoute:
      AuthedDashboardOOrgIdWhiteGloveTasksRoute,
    AuthedDashboardOOrgIdWhiteGloveIndexRoute:
      AuthedDashboardOOrgIdWhiteGloveIndexRoute,
  }

const AuthedDashboardOOrgIdRouteRouteWithChildren =
  AuthedDashboardOOrgIdRouteRoute._addFileChildren(
    AuthedDashboardOOrgIdRouteRouteChildren,
  )

interface AuthedDashboardRouteChildren {
  AuthedDashboardNotificationsRoute: typeof AuthedDashboardNotificationsRoute
  AuthedDashboardIndexRoute: typeof AuthedDashboardIndexRoute
  AuthedDashboardOOrgIdRouteRoute: typeof AuthedDashboardOOrgIdRouteRouteWithChildren
  AuthedDashboardTestCanvasPreviewRoute: typeof AuthedDashboardTestCanvasPreviewRoute
  AuthedDashboardTestCanvaskitRoute: typeof AuthedDashboardTestCanvaskitRoute
}

const AuthedDashboardRouteChildren: AuthedDashboardRouteChildren = {
  AuthedDashboardNotificationsRoute: AuthedDashboardNotificationsRoute,
  AuthedDashboardIndexRoute: AuthedDashboardIndexRoute,
  AuthedDashboardOOrgIdRouteRoute: AuthedDashboardOOrgIdRouteRouteWithChildren,
  AuthedDashboardTestCanvasPreviewRoute: AuthedDashboardTestCanvasPreviewRoute,
  AuthedDashboardTestCanvaskitRoute: AuthedDashboardTestCanvaskitRoute,
}

const AuthedDashboardRouteWithChildren = AuthedDashboardRoute._addFileChildren(
  AuthedDashboardRouteChildren,
)

interface AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteChildren {
  AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute
}

const AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteChildren: AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteChildren =
  {
    AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute:
      AuthedDashboardOOrgIdCClientIdFlowsFlowIdEditRoute,
  }

const AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteWithChildren =
  AuthedDashboardOOrgIdCClientIdFlowsFlowIdRoute._addFileChildren(
    AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedDashboardRoute: typeof AuthedDashboardRouteWithChildren
  AuthedIntegrationsKlaviyoCallbackRoute: typeof AuthedIntegrationsKlaviyoCallbackRoute
  AuthedIntegrationsKlaviyoInstallRoute: typeof AuthedIntegrationsKlaviyoInstallRoute
  AuthedIntegrationsKlaviyoIndexRoute: typeof AuthedIntegrationsKlaviyoIndexRoute
  AuthedDashboardOOrgIdCClientIdFlowsFlowIdRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteWithChildren
  AuthedDashboardOOrgIdCClientIdFlowsCreateRoute: typeof AuthedDashboardOOrgIdCClientIdFlowsCreateRoute
  AuthedDashboardOOrgIdCClientIdSectionsIdRoute: typeof AuthedDashboardOOrgIdCClientIdSectionsIdRoute
  AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute
  AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute: typeof AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedDashboardRoute: AuthedDashboardRouteWithChildren,
  AuthedIntegrationsKlaviyoCallbackRoute:
    AuthedIntegrationsKlaviyoCallbackRoute,
  AuthedIntegrationsKlaviyoInstallRoute: AuthedIntegrationsKlaviyoInstallRoute,
  AuthedIntegrationsKlaviyoIndexRoute: AuthedIntegrationsKlaviyoIndexRoute,
  AuthedDashboardOOrgIdCClientIdFlowsFlowIdRoute:
    AuthedDashboardOOrgIdCClientIdFlowsFlowIdRouteWithChildren,
  AuthedDashboardOOrgIdCClientIdFlowsCreateRoute:
    AuthedDashboardOOrgIdCClientIdFlowsCreateRoute,
  AuthedDashboardOOrgIdCClientIdSectionsIdRoute:
    AuthedDashboardOOrgIdCClientIdSectionsIdRoute,
  AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute:
    AuthedDashboardOOrgIdCClientIdEmailsTemplateIdChatRoute,
  AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute:
    AuthedDashboardOOrgIdCClientIdEmailsTemplateIdEditRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

interface AuthRouteChildren {
  AuthConfirmRoute: typeof AuthConfirmRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthConfirmRoute: AuthConfirmRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminSkidogRouteRoute: AdminSkidogRouteRouteWithChildren,
  WRouteRoute: WRouteRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  FigmaAuthRoute: FigmaAuthRoute,
  OnboardingRoute: OnboardingRoute,
  TestSvgRoute: TestSvgRoute,
  AcceptInvitationTokenRoute: AcceptInvitationTokenRoute,
  PTokenRoute: PTokenRoute,
  PIndexRoute: PIndexRoute,
  ClientTransfersClaimTokenRoute: ClientTransfersClaimTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
